var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange) {
    this.settings();

    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      lap: "(min-width: 1025px) and (max-width: 1279px)",
      desktop: "(min-width: 1280px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false);

let alreadyDelegated = false;
class Popup {
  constructor(element, additionalOverlay) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    if (additionalOverlay == true) {
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }
    if (alreadyDelegated == false) {
      this.bindEvents();
    }

  }
  bindEvents() {
    alreadyDelegated = true;
    this.delegateBody.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );
    this.delegateBody.on(
      "close:other",
      this.closeModal.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.dispatchEvent(
        new CustomEvent("close:other", { bubbles: true })
      );
    }

    this.activeModal = document.getElementById(
      event.target.closest("[aria-controls]").getAttribute("aria-controls")
    );

    if (this.activeModal.getAttribute("aria-hidden") === "false") return;
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.getBoundingClientRect(); // reflow



    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    requestAnimationFrame(() => {

      this.activeModal.setAttribute("aria-expanded", "true");
    });

    this.myCursor = new CustomCursor(false, this.pageOverlayElement, false, true, 'close');



    const focus = this.activeModal.querySelector("[data-scrollable]");

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");

    const focus = this.element.querySelector("[data-scrollable]");

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal(e) {
    e.preventDefault();

    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );

    if (!this.activeModal) return;

    if (this.myCursor) {
      this.myCursor.destroy();
    }

    const handleModalClose = (e) => {
      if (this.activeModal.getAttribute("aria-expanded") === "false" && this.activeModal.getAttribute("aria-hidden") === "false") {
        this.activeModal.setAttribute("aria-hidden", "true");
      };
    }
    if (!this.activeModal) return;



    this.myCursor.destroy();



    this.activeModal.setAttribute("aria-expanded", "false");
    if (this.activeModal.classList.contains('account__popup')) {
      this.activeModal.addEventListener('animationend', handleModalClose, { once: true });
    } else {
      this.activeModal.addEventListener('transitionend', handleModalClose, { once: true });
    }

    const focus = this.activeModal.querySelector("[data-scrollable]");
    bodyScrollLock.enableBodyScroll(focus);
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

  }




  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {

    let images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      index = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      index = event.target.dataset.imagePosition;
      images = [...document.querySelectorAll(".ProductSlider--Image")];
    }


    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }



  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("phone") ? 1200 : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    const contentPrev = document.querySelector(".pswp__button--prev");
    const contentNext = document.querySelector(".pswp__button--next");
    const cursorPrev = contentPrev.querySelector(".pswp__previus-click");
    const cursorNext = contentNext.querySelector(".pswp__next-click");
    this.cursorPrev = new CustomCursor(cursorPrev, contentPrev);
    this.cursorNext = new CustomCursor(cursorNext, contentNext);
    var _this = this;

    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: true,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    const currentIndex = this.photoSwipeInstance.getCurrentIndex() + 1;
    const totalSlides = this.photoSwipeInstance.options.getNumItemsFn();

    // Update our new element
    const counterEl = document.querySelector(".pswp__slide-info");
    if (counterEl) {
      counterEl.textContent = `${currentIndex} / ${totalSlides}`;
    }

    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
    const currentIndex = this.photoSwipeInstance.getCurrentIndex() + 1;
    const totalSlides = this.photoSwipeInstance.options.getNumItemsFn();

    const counterEl = document.querySelector(".pswp__slide-info");
    if (counterEl) {
      counterEl.textContent = `${currentIndex} / ${totalSlides}`;
    }
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains(
      "RevolutionSelectbox--Selectors"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {

    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.delegateBody.on("topbar:slideoff", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));


    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
  }

  findAndScrollToMatch(contentElement, searchQuery) {
    const items = Array.from(contentElement.querySelectorAll(".RevolutionSelectbox--Item"));

    const matchedItem = items.find(item => {
      const itemText = item.textContent.toLowerCase().trim();
      return itemText.startsWith(searchQuery.trim());
    });

    if (matchedItem) {
      matchedItem.focus();
    }
  }

  initSearchWithinDropdown(contentElement) {
    let searchQuery = "";

    this.keydownListener = (event) => {
      if (!this.resetQuery) {
        this.resetQuery = setTimeout(() => {
          searchQuery = "";
          this.resetQuery = null;
        }, 1000);
      }

      searchQuery += event.key.toLowerCase();
      if (searchQuery.length > 0) {
        this.findAndScrollToMatch(contentElement, searchQuery);
      }
    };

    window.addEventListener("keydown", this.keydownListener);
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);

    this.mainButton.querySelector(".variant-select .RevolutionSelectbox--Button span")?this.mainButton.querySelector(".variant-select .RevolutionSelectbox--Button span").style.alignItems = "center":null;
    this.mainButton.querySelector(".variant-select .RevolutionSelectbox--Button span")?this.mainButton.querySelector(".variant-select .RevolutionSelectbox--Button span").style.gap = "1rem":null;
    this.mainButton.querySelector(".RevolutionSelectbox--Title").classList.remove("u-p4");
    this.mainButton.querySelector(".RevolutionSelectbox--Title").classList.add("u-p2");
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }

    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;

    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );

    }


    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.closeDropdown(this.element);

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      responsive.matchesBreakpoint("lap_and_up") &&
      this.headerTransparent
    ) {
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 1);
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 601);
    }
    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });



    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    if (this.element.closest("#modal-country")) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      const height = contentElement.offsetHeight;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';
      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    if (this.element.id == "dropdownSelector" && contentElement.scrollHeight > contentElement.clientHeight) {
      const cursor = contentElement.querySelector(".custom-scroll");

      this.myCursor = new CustomCursor(cursor, contentElement, false, false, false)
    } else if (this.element.closest("#modal-country")) {
      const cursor = contentElement.querySelector(".localization__scroll-cursor");
      this.myCursor = new CustomCursor(cursor, contentElement)
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
    this.initSearchWithinDropdown(contentElement);
  }

  closeDropdown(target) {
    if (this.isOpen == false) { return; }
    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }

    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      responsive.matchesBreakpoint("lap_and_up") &&
      this.headerTransparent &&
      event.type != "menu:open" &&
      !event.target.classList.contains("searchItem") &&
      event.type != "close:search"
    ) {
      setTimeout(() => {
        document.querySelector("#header").classList.add("Header--Transparent");
      }, 601);
    }
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    closestDropdown.querySelector(
      ".RevolutionSelectbox--Content"
    ).style.height = "0px";
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 301);

    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener);
      this.keydownListener = null;
    }

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.remove("is-visible");
      }
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }
    if (this.myCursor) {

      this.myCursor.destroy();
    }

    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus);
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector = false;
    if (responsive.matchesBreakpoint('pocket')) {
      selector = "[data-action=toggle-mobile-dropdown]";
    } else {
      selector = "[data-action=toggle-desktop-dropdown]";
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (responsive.matchesBreakpoint('pocket')) {
        if (
          ((
            !dropdown.classList.contains("do-not-close") &&
            !dropdown.classList.contains('footer__dropdown'))
            ||
            (dropdown.classList.contains('footer__dropdown') && elem.classList.contains('footer__dropdown')))
          && dropdown !== target.closest(".Dropdown") && dropdown.querySelector("[aria-expanded='true']")
        ) {
          this.closeDropdown(dropdown, true);
        }
      } else {
        if (!dropdown.classList.contains("do-not-close") && dropdown !== target.closest(".Dropdown") && dropdown.querySelector("[aria-expanded='true']") && !dropdown.classList.contains('footer__dropdown')) {

          this.closeDropdown(dropdown, true);
        }
      }

    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;
        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
        setTimeout(() => {
          clearInterval(this.scrolling);
        }, 10);
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }



  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          if (elem.classList.contains('footer__dropdown') && responsive.matchesBreakpoint('pocket')) {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";


    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();
class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );


    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {

    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("reachEnd", () => {
      this.element.classList.add("swiper--end");
    });

    this.swiperElement.on("fromEdge", () => {
      this.element.classList.remove("swiper--end");
    });

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }

  destroy() {
    this.swiperElement.destroy();
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.headerHeight = document.body.querySelector("#header")?.offsetHeight || 0;
    this.headerLinks = document.body.querySelector(".header__mobile-links");
    this.headerLogo = document.body.querySelector(".logo");
    this.headerWrapper = document.body.querySelector(".header");
    this.mobileLogo = document.querySelector(".mobile-logo-wrapper");
    this.bottomBar = document.querySelector(".main-header__bottom-bar");
    this.headerDesktopLinks = document.querySelectorAll(".header-links_icon a");


    this.header = document.getElementById("header");
    this.bottomBarParent = document.querySelector(".sticky-bottom-bar");






    if (this.element.getAttribute("drawer-name") === "dopdownMob-DrawerDesk") {
      this.pageOverlayElement = document.querySelector(".pageOverlayPDP");
    } else if (this.element.getAttribute("id") === "sizeGuide") {
      this.pageOverlayElement = document.querySelector(
        ".pageOverlaySizeGuidePDP"
      );
    }

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    if (this.element.getAttribute("data-id") == "mobile-menu") {
      this.footerHeight = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;
      setTimeout(() => {
        document.documentElement.style.setProperty(
          "--mobile-menu-height",
          `${this.footerHeight}px`
        );
      }, 200);

    }
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";
    if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    } else if (this.element.getAttribute("data-id") == "mobile-menu") {
      const viewportHeight = window.innerHeight;

      this.element.style.height = `${viewportHeight - this.annHeight - this.headerHeight}px`;
      const content = this.element.querySelector(".Drawer--Content");
      const footer = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;

      if (content) {
        const parentHeight = parseInt(this.element.style.height, 10);
        const contentHeight = parentHeight - footer;
        content.style.height = `${contentHeight}px`;


      }


    }
    else {
      if (
        (this.element.id === "collection__sort-drawer" ||
          this.element.id === "collection__filter-drawer") &&
        responsive.matchesBreakpoint("lap_and_up")
      ) {
        return;
      }
      const content = this.element.querySelector(".Drawer--Content");
      const header =
        this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      const footer =
        this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;

      if (content) {
        const contentHeight = window.innerHeight - header - footer;
        content.style.height = contentHeight + "px";

        const loader = this.element.querySelector(".spinningLoader");
        if (loader) {
          loader.style.height = contentHeight + "px";
          loader.style.top = header + "px";
        }
      }
    }
  }

  toggleDrawer(e) {
    event.preventDefault();

    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }


  openDrawer() {

    if (this.isOpen) {
      return;
    }

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    this.resizedLogo = document.body
      .querySelector(".resized-logo")
      ? true
      : false;


    this.headerScrolled = document.body
      .querySelector("#header")
      .classList.contains("Header--Scrolled")
      ? true
      : false;

    if (this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
       
      if(this.headerLogo) {
        this.headerLogo.style.filter = "invert(0)";
      }
   
      this.headerWrapper.classList.add("Header--Scrolled");
    }

    if (this.element.id == "Drawer") {
      this.mobileLogo.classList.add("resized-logo");
      this.headerLinks.style.opacity = "1";
      this.headerLinks.style.height = "fit-content";
      setTimeout(() => {
        this.headerLinks.style.display = "flex";
      }, 200);
    }


    this.element.dispatchEvent(
      new CustomEvent("recalculate:header", { bubbles: true })
    );

    document.querySelectorAll(`[data-toggle-id="${this.element.id}"]`).forEach(button => button.setAttribute('aria-expanded', true));

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }




    if (this.element.getAttribute("id") == "Drawer") {
      if (document.querySelector(".Drawer--Close"))
        document.querySelector(".Drawer--Close").style.display = "flex";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );

    } else {
      this.maxHeight();
    }

    if (event && event.target) {
      event.target.setAttribute("aria-expanded", "true");
    }


    this.element.setAttribute("aria-expanded", "true");


    var focus = this.element.querySelector("[data-scrollable]");
    if (!focus) focus = this.element;
    bodyScrollLock.enableBodyScroll(focus);
    document.body.classList.add("scrollLock");

    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);

    let global = true;
    if (
      (this.element.id === "collection__category-drawer" ||
        this.element.id === "collection__filter-drawer")
    ) {
      this.pageOverlayElement = document.querySelector('.collection__overlay');


    }

    this.customCursor = new CustomCursor(false, this.pageOverlayElement, false, global, 'close');
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    if (this.element.getAttribute("data-id") == "mobile-menu") {
      this.hamburger = document.body.querySelector(".header-hamburger");
      this.hamburger.classList.add("is-active");
      this.hamburger.setAttribute('aria-expanded', 'true');
      const viewportHeight = window.innerHeight;
      this.pageOverlayElement.style.height = viewportHeight - this.annHeight - this.headerHeight + "px";
      this.pageOverlayElement.style.bottom = 0;
      const headerIndex = document.body.querySelector("#header").parentElement;
      headerIndex.style.zIndex = 22;
      this.pageOverlayElement.classList.remove("is-visible");

    }
    this.onOpen();

    return false;


  }

  closeDrawer(event) {
    this.element.dispatchEvent(
      new CustomEvent("recalculate:header", { bubbles: true })
    );
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    this.bottomBar.classList.remove("opened-menu");



    document.querySelectorAll(`[data-toggle-id="${this.element.id}"]`).forEach(button => button.setAttribute('aria-expanded', false));

    document.body.classList.remove("scrollLock");
    if (
      this.element.id === "collection__filter-drawer" &&
      ((event && event.type !== "drawer:close-other") || !event)
    ) {
      this.element.style.marginRight = `0`;
    }

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element.setAttribute("aria-expanded", false);
      }
    }


    this.element.setAttribute("aria-expanded", "false");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    this.customCursor.destroy();
    this.bottomBar.style.zIndex = 5;


    if (this.element.getAttribute("data-id") == "mobile-menu") {
      this.hamburger.classList.remove("is-active");
      this.hamburger.setAttribute('aria-expanded', 'false');
      const headerIndex = document.body.querySelector("#header").parentElement;
      setTimeout(() => {
        headerIndex.style.zIndex = '';
      }, 200)
    }
    this.headerLinks.style.opacity = "0";
    this.headerLinks.style.height = "0";
    setTimeout(() => {
      this.headerLinks.style.display = "none";
    }, 200);

    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
    setTimeout(() => {
      if (document.querySelector('#collection__sort-drawer') && document.querySelector('#collection__sort-drawer').getAttribute('aria-expanded') == 'false' && document.querySelector('#collection__filter-drawer') && document.querySelector('#collection__filter-drawer').getAttribute('aria-expanded') == 'false') {
        this.pageOverlayElement.removeAttribute('style');
        document.querySelector('.collection__overlay').classList.remove('is-visible');
      }


    }, 400)

    if (this.headerTransparent && !this.headerScrolled) {

      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
      document.body
        .querySelector("#header")
        .classList.remove("Header--Scrolled");
    }

    if (!this.resizedLogo) {

      this.mobileLogo.classList.remove("resized-logo");
    }




    this.headerLinks.removeAttribute("style");

  }

  translateTransitionEnded() {
    if (
      event.propertyName == "transform" &&
      this.element.getAttribute("aria-expanded") === "false"
    ) {
      if (this.element.getAttribute("id") == "mobile-menu") {
        this.element.dispatchEvent(
          new CustomEvent("menuDrawer:closed", { bubbles: true })
        );
        this.hamburger.style.pointerEvents = "all";

        if (this.headerTransparent) {
          document.body.querySelector("#header").toggleColor();
        }
      }
      if (
        new Responsive().matchesBreakpoint("phone") &&
        this.element.id == "selectorsDrawer"
      )
        return;

      removeTrapFocus(this.element);
      this.element.style.display = "none";

      this.element.removeEventListener(
        "transitionend",
        this.transitionEndedListener
      );
    }
  }
}

class CustomCursor {
  /**
   * @param {HTMLElement} cursorElement       A selector for the element you'd like
   *                                      to use as the "custom cursor".
   * @param {HTMLElement} containerElement 
   *                                      The DOM element you want to track the
   *                                      mouse within (no selector string needed).
   * @param {number} offsetX              Horizontal offset in px (default 5).
   * @param {number} offsetY              Vertical offset in px (default 5).
   */
  constructor(cursorElement, containerElement, swiper = false, globalContainer, cursorType) {
    if (responsive.matchesBreakpoint("phone")) { return }

    // Grab the custom cursor element via its selector
    this.cursor = cursorElement;
    // Use the passed-in DOM element as the container
    this.container = containerElement;
    this.swiper = swiper;
    this.cursorType = cursorType;

    // Bind class methods to `this` for correct context
    this.moveCursorOnSwiper = this.moveCursorOnSwiper.bind(this);
    this.moveCursor = this.moveCursor.bind(this);
    this.enterCursor = this.enterCursor.bind(this);
    this.leaveCursor = this.leaveCursor.bind(this);
    this.appendContainer = this.container;

    // If the container exists, attach the event listeners
    if (!this.container) return;

    this.globalContainer = globalContainer;
    if (swiper) {
      this.container.swiper.on("touchMove", this.moveCursorOnSwiper);
    }

    if (this.globalContainer) {
      this.appendContainer = document.body;
    }

    if (cursorType === "slide") {
      this.cursor = this.generateSlideCursor();
    }

    if (cursorType === "close") {
      this.cursor = this.generateCloseCursor();
      if (!this.globalContainer) { this.appendContainer = this.container.parentElement; }
    }


    this.container.addEventListener("mousemove", this.moveCursor);
    this.container.addEventListener("mouseenter", this.enterCursor);
    this.container.addEventListener("mouseleave", this.leaveCursor);
  }

  generateSlideCursor() {
    const cursor = document.createElement("span");
    cursor.classList.add("cursor-text", "u-p4");
    cursor.innerHTML = window.languages.slide;
    return cursor;
  }

  generateCloseCursor() {
    const cursor = document.createElement("span");
    cursor.classList.add("close-cursor", "u-p2", "not_mobile", "not_pocket");
    cursor.id = "closeCursor";
    cursor.innerHTML = window.languages.close;
    return cursor;
  }

  moveCursorOnSwiper(swiper, event) {
    if (!this.container) return;

    // Get the container’s position in the viewport
    const containerRect = this.container.getBoundingClientRect();
    // Compute mouse coordinates relative to the container’s top-left corner
    const relativeX = event.clientX - containerRect.left;
    const relativeY = event.clientY - containerRect.top;

    this.move(relativeX, relativeY);
  }

  move(relativeX, relativeY) {
    let scrolledY = 0;
    if (this.globalContainer) {
      scrolledY = window.pageYOffset || document.documentElement.scrollTop;
    }


    if (!this.cursor || !this.container) return;
    this.cursor.style.display = "flex";

    // Now apply any offsets
    const finalX = relativeX + this.container.scrollLeft;
    const finalY = relativeY + this.container.scrollTop + scrolledY;



    // Position the custom cursor within the container
    this.cursor.style.left = `${finalX}px`;
    this.cursor.style.top = `${finalY}px`;
  }

  moveCursor(event) {
    if (event.target.closest('.disable-custom-cursor')) {
      if (this.cursor) {
        this.cursor.style.display = "none";
      }
      if (this.appendContainer) {
        this.appendContainer.classList.remove('cursor-active');
        this.appendContainer.style.removeProperty('cursor');
      }
      return; // Skip further processing
    }
    if (!this.container) return;

    // Get the container’s position in the viewport
    const containerRect = this.container.getBoundingClientRect();
    // Compute mouse coordinates relative to the container’s top-left corner
    let relativeX = event.clientX - containerRect.left;
    let relativeY = event.clientY - containerRect.top;
    if (this.globalContainer) {
      relativeX = event.clientX;
      relativeY = event.clientY;
    }


    this.move(relativeX, relativeY);
  }

  enterCursor() {

    if (this.cursorType) {
      this.appendContainer.appendChild(this.cursor);
      this.appendContainer.classList.add('cursor-active');
      this.appendContainer.style.cursor = "none";
    }

    if (!this.cursor) return;
    this.cursor.style.display = "flex";
    this.cursor.style.opacity = "1";
  }

  leaveCursor() {
    if (this.cursorType) {
      this.appendContainer.style.removeProperty('cursor');
      this.appendContainer.classList.remove('cursor-active');
    }
    if (!this.cursor) return;
    this.cursor.style.display = "none";
    this.cursor.style.opacity = "0";
    if (this.cursorType) {
      this.cursor.remove();
    }
  }

  /**
   * Optional cleanup: remove event listeners if needed
   */
  destroy() {

    if (!this.container || !this.cursor) return;
    this.cursor.style.left = "unset";
    this.cursor.style.top = "unset";
    this.cursor.style.display = "none";
    if (this.swiper) this.container.swiper.off("touchMove", this.moveCursorOnSwiper);
    this.container.removeEventListener("mousemove", this.moveCursor);
    this.container.removeEventListener("mouseenter", this.enterCursor);
    this.container.removeEventListener("mouseleave", this.leaveCursor);
    if (this.cursorType) {
      this.appendContainer.classList.remove('cursor-active');
      this.appendContainer.style.removeProperty('cursor');
      this.cursor.remove();
    }
  }
}



class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: 500,
          easing: "ease",
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          elementFadeIn: "elementFadeIn",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
      },
      onOpen: () => {

        this.isOpen = true;
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".spinningLoader");
    this.carouselElement = this.element.querySelector(".helper-recomm-swiper");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.truncateTitleText();
    this.bindEvents();


  }

  bindEvents() {
    if (window.theme.listener == "false") {

      this.onProductAddedListener = this.onProductAdded.bind(this);

      if (this.options["showRecommendations"]) {
        window.addEventListener("load", () => this.loadRecommendations(true));
      }

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on("click", '[data-action="update-item-quantity"], [data-action="remove-item"]', this.updateItemQuantity.bind(this));
      this.delegateElement.on("change", '[data-action="update-change-quantity"]', this.updateItemQuantity.bind(this));
      this.delegateElement.on("quantity:changed", ".cart-item__quantity", this.updateItemQuantity.bind(this));
      this.delegateElement.on("mouseover", this.handleCardHover.bind(this));

      window.theme.listener = "true";
    }
  }

  truncateTitleText() {
    const header = this.element.querySelector('.cart-item__info-header');
    const titles = this.element.querySelectorAll('.cart-item__info-header .cart-drawer__item-title');
    if (!titles.length || !header) return;

    const headerWidth = header.offsetWidth;
    titles.forEach(title => {
      const originalText = title.textContent.trim();
      let truncatedText = originalText;
      title.textContent = originalText;

      while (title.offsetWidth > headerWidth && truncatedText.length > 0) {
        truncatedText = truncatedText.slice(0, -1);
        title.textContent = truncatedText.trim() + '...';
      }
    });
  }



  handleCardHover(event) {
    const hoveredTitleSpan = document.getElementById("hovered-product-title");
    const hoveredCard = event.target.closest('.cart-drawer__rec-item');

    if (hoveredCard) {
      const productTitle = hoveredCard.querySelector('.product-title');
      if (productTitle) {
        hoveredTitleSpan.textContent = productTitle.textContent;
      }
    } else {
      if (hoveredTitleSpan) hoveredTitleSpan.textContent = '';
    }
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }
      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );

      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      const bottomBarCountElements = document.querySelectorAll(".bottom-bar__item-counter");
      const cartItemCountElement = document.querySelector(".cart-drawer__title__item-count");
      if (cartItemCountElement) {
        cartItemCountElement.innerHTML = '';
        cartItemCountElement.innerHTML = `${data.item_count}`;
      }
      if (bottomBarCountElements.length > 0) {
        bottomBarCountElements.forEach((element) => {
          element.innerHTML = '';
          element.innerHTML = `(${data.item_count})`;
        });
      }

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded(event) {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute("data-open-drawer")) {
        if (!this.isOpen) {
          this.isOpen = true;
          if (this.options["showRecommendations"]) {
            this.loadRecommendations();
          }
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
  }

  renderCart(
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );
      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    if (!updateCount) {
      // Prepare the page loader animation
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    const oldItemCount = this.options.itemCount || 0;
    this.options = newOptions;

    const itemCount = newOptions.itemCount;

    window.theme.cartCount = parseInt(itemCount);

    const bottomBarCountElements = document.querySelectorAll(".bottom-bar__item-counter");
    const cartItemCountElement = document.querySelector(".cart-drawer__title__item-count");
    if (cartItemCountElement) {
      cartItemCountElement.innerHTML = '';
      cartItemCountElement.innerHTML = `${window.theme.cartCount}`;
    }
    if (bottomBarCountElements.length > 0) {
      bottomBarCountElements.forEach((element) => {
        element.innerHTML = '';
        element.innerHTML = `${window.theme.cartCount}`;
      });
    }

    this.updateCartFooter(tempElement);

    if (updateCount) return;
    if (lineNumber) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && oldItemCount > 1) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    // Additional actions after a brief delay
    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {

        this.loadRecommendations();
      }
      const focusElement = this.element.querySelector("[data-scrollable]");
      if (this.element.hasAttribute("data-open-drawer")) {
        bodyScrollLock.disableBodyScroll(focusElement, bodyScrollLockOptions);
      }
      this.drawer.maxHeight();
    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info`
    );

    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.replaceChild(
        newCartItemInfo,
        cartItemParent.querySelector(".cart-item__info")
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }



  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;

    const cartFooter = this.element.querySelector(".cart-drawer__footer");

    if (tempElement.querySelector(".cart-drawer__footer") && !cartFooter) {

      this.element.appendChild(tempElement.querySelector(".cart-drawer__footer"));
    } else if (tempElement.querySelector(".cart-drawer__footer") && cartFooter) {

      this.element.replaceChild(tempElement.querySelector(".cart-drawer__footer"), cartFooter);
    }

    if (itemCount > 0) {
      const footerParent = this.element.querySelector(".cart-drawer__footer");
      const newFooterTotals = tempElement.querySelector(
        ".cart-drawer__footer-subtotal"
      );
      if (!footerParent || !newFooterTotals) return;
      footerParent.replaceChild(
        newFooterTotals,
        footerParent.querySelector(".cart-drawer__footer-subtotal")
      );

      this.drawer.maxHeight();
    } else {
      this.clearCartFooter(tempElement);
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__content")) return;
    const cartFooter = this.element.querySelector(".cart-drawer__footer");
    if (cartFooter) {
      cartFooter.classList.add("removing");
      cartFooter.addEventListener("transitionend", () => {
        cartFooter.remove();
        this.drawer.maxHeight();
      }, { once: true });
    }
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__content"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__content"),
      this.element.querySelector(".cart-drawer__content")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;

    this.drawer.maxHeight();
  }

  loadRecommendations(firstLoad, related, callNumber) {
    if (callNumber > 10) return;

    let recommendationsContainer = this.element.querySelector(".cart-drawer__recommendations");

    if (this.recommendationLoading == true || (this.isOpen == false && !firstLoad) || !recommendationsContainer) return;
    this.recommendationLoading = true;

    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}&intent=complementary`;
      if (related) {
        url = url.replace('complementary', 'related');
      }
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        if (!container.querySelector('.cart-drawer__rec-item')) {
          this.loadRecommendations(firstLoad, true, callNumber ? callNumber + 1 : 1);
          return;
        }

        let recommendationsHTML = container.querySelector(".cart-drawer__upsell")?.innerHTML;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.setAttribute(
            "data-animation",
            "elementFromRight"
          );
          new RevolutionAnimation();
          if (recommendationsContainer.querySelector('.swiper-wrapper').scrollWidth > 480) {
            new CustomCursor(false, recommendationsContainer, false, false, 'slide');
          }

        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 3.2,
      spaceBetween: 4,
      scrollbar: {
        el: ".cart-recommendations__pagination",
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 4,
          spaceBetween: 4,
        },
      },
    });
  }
}
customElements.define("cart-drawer", cartDrawer);

class MainCart extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = _this;



    this.truncateTitleText();
  }

  truncateTitleText() {
    const header = this.element.querySelector('.cart-item__info-header');
    const titles = this.element.querySelectorAll('.cart-item__info-header .cart-drawer__item-title');

    if (!titles.length || !header) return;

    const headerWidth = header.offsetWidth;
    titles.forEach(title => {
      const originalText = title.textContent.trim();
      let truncatedText = originalText;
      title.textContent = originalText;


      while (title.offsetWidth > headerWidth && truncatedText.length > 0) {

        truncatedText = truncatedText.slice(0, -1);
        title.textContent = truncatedText.trim() + '...';
      }
    });
  }
}

customElements.define("main-cart", MainCart);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".featured-collection__swiper");

    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {

    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
    new CustomCursor(false, this.carouselElement.querySelector('.swiper-wrapper'), false, false, 'slide');
  }


}
customElements.define("featured-collection", FeaturedCollectionSection);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = _this;
    this.delegateElement = new Delegate(this.element);

    try {
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
      );
    } catch (error) {
      console.error("Unable to parse section options");
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="redirect"]',
      this.redirectTo.bind(this)
    );
  }

  redirectTo(event) {
    event.preventDefault();
    const targetIndex = event.target.getAttribute('data-index');

    if (targetIndex !== null && this.options[targetIndex]) {
      const redirectURL = this.options[targetIndex].redirectURL;

      if (redirectURL) {
        window.location.href = redirectURL;
      } else {
        console.error("Redirect URL is missing");
      }
    } else {
      console.error("Invalid target index or options array");
    }
  }
}

customElements.define("collection-showcase", CollectionShowcase);


class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.carouselElement = this.element.querySelector(".product-card-swiper");

    if (!this.carouselElement) return;
    this.carousel = new RevolutionSwiper(this.carouselElement);

  }


}
customElements.define("product-card", ProductCard);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);

      if (this.carousel.swiperElement) {
        this.carousel.swiperElement.on("reachBeginning", () => {
          if (this.carousel.swiperElement.params.rewind && this.carousel.swiperElement.params.autoplay) {
            this.carousel.swiperElement.autoplay.stop();
          }
        })
      }

      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(
          "not_mobile.Banner__Image"
        );
      } else {
        imageToReveal = imageContainers[0].querySelector(
          "not_mobile.Banner__Image"
        );
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }

    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.closeTextElement = document.getElementById("closeText");
    this.headerTransparent = false;
    this.pageOverlayElement = document.querySelector(".desktop-menu--overlay");

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }

    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
    this.checkBanner();
    this.headerHover();
  }

  bindEvents() {
    this.updateBodyClassListner = this.updateBodyClass.bind(this);
    this.mainScrollListener = scrollListener.addScrollListener(this, this.updateBodyClassListner);

    if (this.options.transparent || this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    this.closeMenuListener = this.closeMenu.bind(this);
    this.openMenuListener = this.openMenu.bind(this);

    if (this.options.sticky) {
      this.toggleTopBarListener = this.toggleTopBar.bind(this);
    }

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );


    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",

      this.closeMenuListener,

      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenuListener,
      true
    );

    this.delegateBody.on("menu:close", this.closeMenuListener);

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
    window.addEventListener("scroll", this.toggleTopBarListener);

    document.addEventListener("recalculate:header", this.updateVisibleHeight.bind(this));

    document.addEventListener('click', this.closeMenuListener);


  }

  toggleTopBar() {
    const currentScroll = window.scrollY;
    const elementHeight = this.element.offsetHeight;

    if (currentScroll > elementHeight * 2) {
      this.showTopBar();
    }
    this.prevOffset = currentScroll;
  }

  showTopBar() {
    this.element.parentElement.classList.add("header--fixed-top-bar");
  }



  hideHeader() {

    document.documentElement.style.setProperty(
      "--header-dynamic-height",
      `0px`
    );
  }

  updateBodyClass(){
    const currentScroll = window.scrollY;
    if(currentScroll > 100) {
      document.body.classList.add("has-scrolled");

      this.mainScrollListener.removeScrollListener(this, this.updateBodyClassListner);
    }
  }

  showHeader() {
    this.element.parentElement.style.transform = `translateY(0)`;
    this.element.parentElement.classList.remove("header--hide");
    this.updateVisibleHeight();
  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );


    }, 301);
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {


    if (
      target.getAttribute("aria-expanded") == 'true' ||
      (event.type === "mouseenter" && target !== event.target)
    ) {
      return;
    }
  
    // Dispatch a custom event to indicate that the menu is being opened
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // If the event is a mouseenter event and the target is not the same as the event target, return.


    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    this.listener = target.parentElement.querySelector(
      ".desktop-menu_dropdown"
    );

    this.pointerTarget = target.closest(".header-links");
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );

    this.pageOverlayElement.classList.add("is-visible");
    if (!this.overlayCursor) {
      this.overlayCursor = new CustomCursor(false, this.pageOverlayElement, false, true, 'close');
    }

  }

  closeMenu(event) {

    if (!this.element || !this.element.querySelector('[aria-expanded="true"]')) return;
    const openElement = this.element.querySelector('[aria-expanded="true"]');

    // Check if the click happened outside the menu

    const isClickOutside = !openElement.contains(event.target) || event.target.classList.contains("desktop-menu--overlay");



    if (!isClickOutside) return;

    if (this.overlayCursor) {
      this.overlayCursor.destroy();
      this.overlayCursor = null;
    }

    this.listener = openElement.querySelector(".desktop-menu_dropdown");
    if (!this.listener) return;
    this.pointerTarget = openElement;
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);

    openElement.setAttribute("aria-expanded", "false");

  
    bodyScrollLock.enableBodyScroll(this.scrollableElement);
    this.pageOverlayElement.classList.remove("is-visible");

    this.toggleColor();
  }



  toggleColor() {
    let bannerHeight;

    const bannerElement = document.body.querySelector(".Banner__Slideshow");
    if (bannerElement) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        bannerHeight = bannerElement.offsetHeight - 174;
      } else {
        bannerHeight = bannerElement.offsetHeight - 106;
      }
    }
    const currentScrollTop = window.pageYOffset;
    if (this.options.transparent && this.headerTransparent && currentScrollTop <= 25) {
      this.element.classList.add("Header--Transparent");
    }


    if ((Math.abs(currentScrollTop - this.lastScrollTop)) < 100) return;

    this.lastScrollTop = currentScrollTop;

    if (currentScrollTop > bannerHeight) {
      this.element.classList.add("Header--Scrolled");
      this.element.classList.remove("Header--Transparent");
    } else {
      this.element.classList.remove("Header--Scrolled");
      this.element.classList.add("Header--Transparent");
    }
    

   
  }



  headerHover() {
    const header = document.getElementById("header");
    const target = document.getElementById("desktopLogo");

    if (this.options.transparent && this.headerTransparent) {
      this.element.classList.remove("Header--Transparent");
    }

    header.addEventListener("mouseenter", () => {
      target.style.pointerEvents = "auto";
    });

    header.addEventListener("mouseleave", () => {
      target.style.pointerEvents = "none";
    });


  }

  checkBanner() {
    const logoWrappers = document.querySelectorAll(".header-logo_wrapper");
    if (document.querySelector("banner-hero")) {
      logoWrappers.forEach((logoWrapper) => {
        logoWrapper.classList.remove("resized-logo");
      });

    }
  }

}
customElements.define("header-component", Header);

class BottomBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);


    this.bottomMenuBar = this.element.querySelector('.main-header__bottom-bar');
    this.sections = document.body.querySelectorAll('[data-mobile-schema]');
    this.moibleMenuSettingsColors = document.body.querySelector('.MobileMenu--wrapper').dataset.mobileSchema;

    this.bindEvents();
  }

  bindEvents() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);

    this.delegateBody.on(
      'click',
      '#hamburger-menu-icon[aria-expanded="false"]',
      this.handleScrollWhenMenuIsOpen.bind(this)
    );

    this.delegateBody.on(
      'click',
      '#hamburger-menu-icon[aria-expanded="true"]',
      this.AddScrollEventListener.bind(this)
    );
  }

  AddScrollEventListener() {
    // Re-add scroll event when menu is closed
    window.addEventListener('scroll', this.handleScroll);
  }
  handleScrollWhenMenuIsOpen() {

    // Remove scroll event while menu is open
    window.removeEventListener('scroll', this.handleScroll);

    this.bottomMenuBar.setAttribute('data-colors', this.moibleMenuSettingsColors);
    this.bottomMenuBar.style.zIndex = '23';

  }
  handleScroll(event) {
    const atTheBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 110;


    this.bottomMenuBar.style.zIndex = '7';
    const barRect = this.bottomMenuBar.getBoundingClientRect();
    let activeSchema = null;

    this.sections.forEach((section) => {
      const sectionRect = section.getBoundingClientRect();

      // Check if bottom bar is over the section
      if (
        barRect.bottom > sectionRect.top &&
        barRect.top < sectionRect.bottom
      ) {
        activeSchema = section.getAttribute('data-mobile-schema');
      }
    });

    if (activeSchema) {
      this.bottomMenuBar.setAttribute('data-colors', activeSchema);
    }

    if (atTheBottom) {
      this.bottomMenuBar.classList.add('hide-mobile-bar');
    } else {
      this.bottomMenuBar.classList.remove('hide-mobile-bar');
    }
  }



}
customElements.define("bottom-bar", BottomBar);



class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;


    const allDrawer = this.element.querySelector(".Drawer--wrapper");
    new Drawer(allDrawer);


  }



}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    this.toggleScroll();
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 200,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
      setTimeout(() => {
        document.querySelectorAll('.header-logo_wrapper').forEach((logoWrapper) => { logoWrapper.style.removeProperty('transition') });
      }, 201);
    }
  }

  toggleScroll() {
    let bannerHeight;

    const bannerElement = document.body.querySelector("banner-hero[data-first]");

    if (bannerElement) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        bannerHeight = bannerElement.offsetHeight - 174;
      } else {
        bannerHeight = bannerElement.offsetHeight - 106;
      }
    } else {
      document.querySelectorAll('.header-logo_wrapper').forEach((logoWrapper) => {
        logoWrapper.style.transition = 'unset';
        logoWrapper.classList.add('resized-logo');

      });
    }
    if (!bannerElement) return;
    const currentScrollTop = window.pageYOffset;
    const rect = bannerElement.getBoundingClientRect();
    const pixelHeight = rect.height;
    if (currentScrollTop > pixelHeight) {



      document.querySelectorAll('.header-logo_wrapper').forEach((logoWrapper) => { logoWrapper.style.transition = 'unset' });
      document.querySelector('#header').classList.add("Header--Scrolled");
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      let lastTouchTime = 0;

      if (host == "html5") {
        this.videoPlayer.on("touchstart", function (e) {
          lastTouchTime = new Date().getTime();


          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      this.videoPlayer.on("click", function () {


        if (new Date().getTime() - lastTouchTime < 300) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  bindCustomControls() {
    this.stateElement = this.element.querySelector(
      "[data-action='toggle-state']"
    );
    this.soundElement = this.element.querySelector(
      "[data-action='toggle-sound']"
    );

    if (!this.stateElement || !this.soundElement) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () =>
      this.videoPlayer.paused()
        ? this.videoPlayer.play()
        : this.videoPlayer.pause()
    );
    this.delegateElement.on("click", "[data-action='toggle-sound']", () =>
      this.videoPlayer.muted()
        ? this.videoPlayer.muted(false)
        : this.videoPlayer.muted(true)
    );

    this.videoPlayer.on("play", () =>
      this.stateElement.setAttribute("aria-label", "playing")
    );
    this.videoPlayer.on("pause", () =>
      this.stateElement.setAttribute("aria-label", "paused")
    );
    this.videoPlayer.on("volumechange", () =>
      this.soundElement.setAttribute(
        "aria-label",
        this.videoPlayer.muted() ? "muted" : "unmuted"
      )
    );
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.mainContent = document.querySelector('.body-wrapper');

    this.bindEvents();

    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.element.offsetHeight + "px"
    );

    document.documentElement.style.setProperty(
      "--footer-height",
      this.element.offsetHeight + "px"
    );

  }

  bindEvents() {
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.element.offsetHeight + "px"
      );
      document.documentElement.style.setProperty(
        "--footer-height",
        this.element.offsetHeight + "px"
      );
      if (responsive.matchesBreakpoint('lap_and_up')) {
        this.element.classList.add('set-height');
      }

      if (!responsive.matchesBreakpoint('lap_and_up')) {

        return;
      }
      else {
        if (document.documentElement.scrollHeight - window.innerHeight < this.element.offsetHeight) {
          document.querySelector('footer').classList.add('footer--relative');
        } else {
          responsive.addResizeListener(this, () => {
            this.element.classList.remove('set-height');
            document.documentElement.style.setProperty(
              "--footer-dynamic-height",
              this.element.offsetHeight + "px"
            );
            if (responsive.matchesBreakpoint('lap_and_up')) {
              this.element.classList.add('set-height');
            }
          });

          if (responsive.matchesBreakpoint('pocket') && !document.querySelector('.footer--relative')) {
            const resizeObserver = new ResizeObserver((entries) => {
              for (const entry of entries) {
                const { width, height } = entry.contentRect;
                document.body.style.paddingBottom = height + 'px';
              }
            });

            resizeObserver.observe(document.querySelector('footer'));
          }
        }
      }
    });
  }
}
customElements.define("footer-component", FooterComponent);

class DropdownPDP {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.dropdownElements = this.element.querySelectorAll(".product-info__dropdown");
    this.blockWrapper = this.element.querySelector(".product-info__additional-content");

    this.initializeDropdown();
  }

  initializeDropdown() {
    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();

    if (this.shouldInitializeDropdown(breakpoint)) {
      this.handleFirst();
      this.bindEvents();
    }
  }

  shouldInitializeDropdown(breakpoint) {
    return (
      (breakpoint === "phone" || breakpoint === "tablet") &&
      this.element.getAttribute("id") !== "size-guide-drawer-contentID"
    );
  }

  handleFirst() {
    const dropdownEl = this.element.querySelector(".product-info__dropdown");

    if (!dropdownEl) return; // Exit if no dropdown element found

    const dropdownButton = dropdownEl.querySelector(".product-info__dropdown-button");
    const dropdownElContent = dropdownEl.querySelector(".product-info__dropdown-wrapper");

    if (dropdownButton && dropdownElContent) {
      dropdownButton.setAttribute("aria-expanded", "true");
      dropdownElContent.setAttribute("aria-hidden", "false");

      // Set height of the dropdown content and block wrapper
      this.setHeight(this.blockWrapper, dropdownElContent);

      // Ensure the parent dropdown element reflects the expanded state
      dropdownEl.setAttribute("aria-expanded", "true");
    }
  }


  setHeight(el, absolutEl) {
    if (el && absolutEl) {
      const isExpanded = el.getAttribute('aria-expanded') === 'true';
      const calculatedHeight = absolutEl.offsetHeight + this.getHeightOfBtn();

      if (!isExpanded) {
        // Only reset height if not expanded
        el.style.height = `${Math.min(calculatedHeight, 296)}px`;
        el.querySelector('.product-info__dropdown-wrapper').style.height = `${Math.min(calculatedHeight, 295)}px`;
        el.querySelector('.product-info__dropdown-content').style.height = `${Math.min(calculatedHeight, 224)}px`;
      }

      // Adjust toggle visibility only for the current tab
      this.setMoreLessButton(el);
    }
  }


  setMoreLessButton(el) {
    // Hide all toggle buttons in all tabs
    const allToggleButtons = document.querySelectorAll('.product-info__content-toggle');
    allToggleButtons.forEach((toggleButton) => {
      toggleButton.style.display = 'none';
    });

    // Handle the specific dropdown content for the current open tab
    const innerContent = el.querySelector('.product-info__dropdown-content');
    const toggleButton = el.querySelector('.product-info__content-toggle');

    if (!innerContent || !toggleButton) return;

    const innerContentHeight = innerContent.scrollHeight;

    if (innerContentHeight > 224) {
      // Show the toggle button for the current dropdown
      toggleButton.style.display = 'block';
      el.setAttribute('aria-expanded', 'false');
      innerContent.style.height = '224px'; // Set initial height for collapsed state
      allToggleButtons.forEach(btn => {
        const btnTxt = btn.querySelectorAll('.ButtonText');
        btnTxt.forEach(txt => {
          txt.textContent = window.variantStrings.read_more;
        })

      })
    } else {
      // Fully expand the content and ensure no toggle button is visible
      toggleButton.style.display = 'none';
      el.setAttribute('aria-expanded', 'true');
      innerContent.style.height = `${innerContentHeight}px`;
      allToggleButtons.forEach(btn => {
        const btnTxt = btn.querySelectorAll('.ButtonText');
        btnTxt.forEach(txt => {
          txt.textContent = window.variantStrings.read_less;
        })

      })
    }
  }


  collapseContent(elToHandle) {


    const elementToHandle = elToHandle;

    const content = elementToHandle.querySelector('.product-info__dropdown-content');
    const allText = elToHandle.querySelectorAll('.ButtonText');


    elementToHandle.style.height = "266px";
    content.style.height = "224px";

    elementToHandle.setAttribute('aria-expanded', 'false');
    allText.forEach((item) => {
      item.textContent = window.languages.read_more;
    });


  }

  toggleContent(event, target) {
    event.preventDefault();

    const elementToHandle = target?.parentElement;

    const content = elementToHandle.querySelector('.product-info__dropdown-content');
    const allText = target.querySelectorAll('.ButtonText');
    if (elementToHandle.getAttribute('aria-expanded') === 'false') {
      const fullHeight = content.scrollHeight;

      this.blockWrapper.style.height = `${fullHeight + 72}px`;
      elementToHandle.style.height = `${fullHeight + 72}px`;
      content.style.height = `${fullHeight}px`;

      elementToHandle.setAttribute('aria-expanded', 'true');

      allText.forEach((item) => {
        item.textContent = window.variantStrings.read_less;
      });

    } else {
      this.blockWrapper.style.height = "296px";
      elementToHandle.style.height = "266px";
      content.style.height = "224px";


      elementToHandle.setAttribute('aria-expanded', 'false');
      allText.forEach((item) => {
        item.textContent = window.variantStrings.read_more;
      });

    }
  }

  getHeightOfBtn() {
    return this.element.querySelector(".product-info__dropdown-button")?.offsetHeight || 0;
  }

  bindEvents() {
    if (this.domDelegate) {
      this.domDelegate.on("click", "[data-action=toggle-dropdown-pdp]", this.handleDropdown.bind(this));
      this.domDelegate.on("click", "[data-action=toggle-content]", this.toggleContent.bind(this));
    }
  }

  handleDropdown(event, target) {
    event.preventDefault();
    const allContents = this.element.querySelectorAll('.product-info__dropdown-wrapper');
    allContents.forEach((content) => {
      this.collapseContent(content);
    });
    const elementToHandle = target?.parentNode;
    this.blockWrapper.style.height = "296px";
    if (elementToHandle) {
      const dropdownButton = elementToHandle.querySelector(".product-info__dropdown-button");

      if (dropdownButton?.getAttribute("aria-expanded") === "false") {
        this.closeOtherContent(elementToHandle);

        dropdownButton.setAttribute("aria-expanded", "true");
        elementToHandle.querySelector(".product-info__dropdown-wrapper").setAttribute("aria-hidden", "false");
        const contentHeight = elementToHandle.querySelector('.product-info__dropdown-wrapper[aria-hidden="false"]');
        this.setHeight(elementToHandle, contentHeight);
      }
    }
  }

  closeOtherContent(el) {
    const openEl = this.element.querySelector('.product-info__dropdown-button[aria-expanded="true"]');
    const parentEl = openEl?.parentNode;

    if (openEl && parentEl) {
      openEl.setAttribute("aria-expanded", "false");
      parentEl.querySelector(".product-info__dropdown-wrapper").setAttribute("aria-hidden", "true");
    }
  }
}

// Define the ProductElement class as a custom HTML element
class ProductElement extends HTMLElement {
  constructor() {
    super();

    // Initialize properties
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");

    // Parse options from data attribute
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    // Complementary products wrapper
    this.complementaryEl = this.element.querySelector(
      ".product-info__complementary"
    );



    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    // Handle dropdown for additional content on mobile
    if (
      this.element.querySelector(".product-info__additional-content") &&
      responsive.matchesBreakpoint("pocket")
    ) {
      new DropdownPDP(this.element.querySelector(".product-info__wrapper"));
    }

    // Initialize drawers for tabs
    const allDrawers = this.element.querySelectorAll('.drawer__pdp-tabs');
    allDrawers.forEach((item) => {
      if (item.id == 'drawer__pdp-tabs' && responsive.matchesBreakpoint("desktop")) {
        this.setUpTabsContent();
        new Drawer(item);
      } else if (item.dataset.name != 'drawer__pdp-tabs') {
        new Drawer(item);
      }
    });

    // Handle image quality and product options
    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );

    // Add to cart functionality
    new AddToCart(this.element);

    // Initialize carousel for mobile
    if (this.options["slides_number"] > 1 && responsive.matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

    // Enable image zoom if configured
    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }


    // Update image based on variant if configured
    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }
    if (this.options["sticky_atc"]) {
      // Sticky Add to Cart elements
      this.stickyAtcWrapper = this.element.querySelector(
        ".pdp-sticky-product-atc"
      );
      document.body.classList.add('has-sticky');

    } else {
      document.body.classList.remove('has-sticky');
    }
    this.mainAtc = this.element.querySelector(".product-info__actions");

    //desktop fraction nav
    this.deskNav = this.element.querySelector('.navigation-fraction-desk-sticky');
    this.navWrapperDesk = this.element.querySelector('.pdp-navigation-fraction-desk');
    this.isElementOverImage = false; // Reset the flag at the start

    if (this.deskNav) {
      this.fractionIndex = document.querySelector(".nav-fraction-index");
      this.imageElements = [...document.querySelectorAll("[data-slide-index]")];
      this.isElementOverImage = false; // Reset the flag at the start
      this.updateFractionIndex();
    }
    this.updateFractionIndex(); // Run on load in case it's already positioned
    // Bind event listeners
    this.bindEvents();
  }

  updateFractionIndex() {
    const navRect = this.deskNav.getBoundingClientRect();
    const swiperRect = this.element.querySelector('.swiper.mainSwiper').getBoundingClientRect();
    let activeImagePosition = 1; // Default to 1

    // Check if the navigation element is within the swiper element
    if (navRect.bottom < swiperRect.bottom) {
      // Hide the nav if it's outside of the swiper element
      this.isElementOverImage = true; // Reset the flag at the start

    } else {
      this.isElementOverImage = false; // Reset the flag at the start
    }

    this.imageElements.forEach((imageEl) => {
      const imgRect = imageEl.getBoundingClientRect();

      if (navRect.top >= imgRect.top - 24 && navRect.top <= imgRect.bottom) {
        activeImagePosition = imageEl.getAttribute("data-slide-index");

      }
    });

    this.fractionIndex.textContent = activeImagePosition;

    if (this.isElementOverImage) {
      this.navWrapperDesk.classList.remove('hide-el');
    } else {
      this.navWrapperDesk.classList.add('hide-el');
    }

  }

  // Bind event listeners for DOM events
  bindEvents() {
    this.domDelegate.on("price:change", this.updatePrice.bind(this));
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.domDelegate.on(
      "click",
      "[data-action=select-options]",
      this.selectOptionsAlert.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=go-to-select-options]",
      this.scrollToTheBlock.bind(this)
    );
    this.domDelegate.on(
      "click",
      "[data-action='toggle-tab']",
      this.switchTab.bind(this)
    );
    this.domDelegate.on(
      "click",
      "[data-action='toggle-drawer']",
      this.openDrawerWithTab.bind(this)
    );

    this.domDelegate.on(
      "mouseenter",
      "[data-action='change-name']",
      this.changeName.bind(this), true
    );

    this.domDelegate.on(
      "mouseleave",
      "[data-action='change-name']",
      this.changeName.bind(this), true
    );

    if (this.deskNav) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
    }
    // Sticky Add to Cart functionality
    if (this.options["sticky_atc"]) {
      scrollListener.addScrollListener(this, this.updateFractionIndex.bind(this));
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      window.addEventListener(
        "DOMContentLoaded",
        this.showStickyAtc.bind(this)
      );
    }
  }

  changeName(event) {

    const eventType = event.type;
    const nameHolder = this.element.querySelector('.product-info__complementary-name');

    if (eventType === 'mouseenter') {
      const name = event.target.dataset.name;
      nameHolder.textContent = name;
    } else if (eventType === 'mouseleave') {
      nameHolder.textContent = "";
    }

  }
  scrollToTheBlock(event) {
    event.preventDefault();

    const blockId = this.element.querySelector("variant-selects");
    if (blockId) {
      const offset = -100; // Adjust this value to scroll more to the top or bottom
      const elementPosition = blockId.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }

  }

  selectOptionsAlert(event) {
    event.preventDefault();
    const errAlert = this.element.querySelector('.pdp-select-options-alert');
    errAlert.classList.add('visible');

    setTimeout(() => {
      errAlert.classList.remove('visible');

    }, 1000);
  }

  // Open drawer and optionally switch to a specific tab
  openDrawerWithTab(event) {
    const button = event.target.closest("[data-action='toggle-drawer']");
    const tabId = button.getAttribute("data-tab-id");

    const drawerId = button.getAttribute("data-toggle-id");
    const drawer = document.getElementById(drawerId);
    if (drawer) {
      drawer.setAttribute("aria-expanded", "true");
      if (tabId) {
        this.switchTabById(tabId);
      }
    }
  }

  // Set up tab content dynamically
  setUpTabsContent() {
    const allTemplates = this.element.querySelectorAll(".tabs-template");
    const drawer = this.element.querySelector(".drawer__pdp-tabs");
    const contentWrapper = drawer.querySelector(".pdp-tabs__wrapper");
    const footer = drawer.querySelector(".drawer__pdp-tabs__footer");

    if (!allTemplates.length) return;

    allTemplates.forEach((template, index) => {
      const tabName = template.getAttribute("data-name");
      const tabId = template.getAttribute("data-title");
      const tabContent = template.innerHTML;

      const content = document.createElement("div");
      content.classList.add("pdp-tabs__content", "rte", "u-p1");
      content.setAttribute("data-id", tabId);
      content.innerHTML = tabContent;
      content.style.display = index === 0 ? "block" : "none";
      contentWrapper.appendChild(content);

      const tabButton = document.createElement("button");
      tabButton.classList.add("Button", "Button--TertiaryOnLight", "Button--Normal");
      tabButton.setAttribute("data-id", tabId);
      tabButton.setAttribute("data-action", "toggle-tab");

      const buttonTextContainer = document.createElement("div");
      buttonTextContainer.classList.add("ButtonTextContainer");

      const buttonTextStart = document.createElement("span");
      buttonTextStart.classList.add("ButtonText", "ButtonTextStart", "u-p2");
      buttonTextStart.textContent = tabName;

      const buttonTextBelow = document.createElement("span");
      buttonTextBelow.classList.add("ButtonText", "ButtonTextBelow", "u-p2");
      buttonTextBelow.textContent = tabName;

      buttonTextContainer.appendChild(buttonTextStart);
      buttonTextContainer.appendChild(buttonTextBelow);
      tabButton.appendChild(buttonTextContainer);

      if (index === 0) {
        tabButton.classList.add("active");
      }

      footer.appendChild(tabButton);
    });
  }

  // Switch to a specific tab by ID
  switchTabById(tabId) {
    const drawer = this.element.querySelector(".drawer__pdp-tabs");
    const contentWrapper = drawer.querySelector(".pdp-tabs__wrapper");
    const footer = drawer.querySelector(".drawer__pdp-tabs__footer");

    contentWrapper.querySelectorAll(".pdp-tabs__content").forEach((content) => {
      content.style.display = "none";
    });
    footer.querySelectorAll("button").forEach((button) => {

      button.classList.remove("active");
    });

    const targetContent = contentWrapper.querySelector(`[data-id="${tabId}"]`);
    const targetButton = footer.querySelector(`[data-id="${tabId}"]`);

    if (targetContent) {
      targetContent.style.display = "block";
    }
    if (targetButton) {
      targetButton.classList.add("active");
    }
  }

  // Handle tab switching
  switchTab(event) {
    const tabButton = event.target;
    const tabId = tabButton.getAttribute("data-id");
    const drawer = this.element.querySelector(".drawer__pdp-tabs");
    const contentWrapper = drawer.querySelector(".pdp-tabs__wrapper");
    const footer = drawer.querySelector(".drawer__pdp-tabs__footer");

    contentWrapper.querySelectorAll(".pdp-tabs__content").forEach((content) => {
      content.style.display = "none";
    });
    footer.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
    });

    const targetContent = contentWrapper.querySelector(`[data-id="${tabId}"]`);
    if (targetContent) {
      targetContent.style.display = "block";
    }
    tabButton.classList.add("active");
  }

  // Update price information on the page
  updatePrice(event) {
    const priceToBeChanged = this.element.querySelectorAll(".mainProductPrice, .variant_price");
    const comparePriceToBeChanged = this.element.querySelectorAll(
      ".variant_compare_at_price"
    );

    let quantity = 1;

    if (event.detail.eventName === "variant") {
      const newSinglePrice = parseInt(event.detail.price_raw);
      const newFinalPrice = newSinglePrice;
      const priceFormatted = Shopify.formatMoney(
        quantity * newFinalPrice,
        window.theme.moneyFormat
      );
      priceToBeChanged.forEach((price) => {
        price.innerHTML = priceFormatted;
      });

      const newCompareAtPrice = parseInt(event.detail.compare_at_price);
      const priceFormattedCompare = Shopify.formatMoney(
        quantity * newCompareAtPrice,
        window.theme.moneyFormat
      );

      comparePriceToBeChanged.forEach((price) => {
        newCompareAtPrice === 0 || !newCompareAtPrice
          ? (price.style.display = "none")
          : (price.style.display = "");
        price.innerHTML = priceFormattedCompare;
      });
    }
  }

  // Hide the sticky Add to Cart button with a timeout
  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  // Show the sticky Add to Cart button based on scroll position
  showStickyAtc() {
    if (this.hideSticky) return;

    const options = {
      root: null, // viewport
      threshold: 0, // triggers as soon as any part is visible or hidden
    };

    const footerHeight = document.querySelector("footer").offsetHeight;
    const atTheBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;

    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.mainAtcVisible = true;
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          document.body.classList.remove('has-sticky');
        } else {
          this.mainAtcVisible = false;
          if (!this.footerVisible) {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
            document.body.classList.add('has-sticky');
          }
        }
      });
    }, options);


    if (atTheBottom) {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
      document.body.classList.remove('has-sticky');
    } else {
      atcObserver.observe(this.mainAtc);
    }
  }

  // Update the product image based on the selected variant
  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
      slideElement
    );

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  // Handle fetching and displaying complementary products
  async handleComplementaryProducts() {
    this.block_options = JSON.parse(
      this.complementaryEl.getAttribute("data-block-settings")
    );
    let optionToUse = this.block_options.select_type;
    this.complementaryElWrapper = this.element.querySelector(
      ".product-info__complementary"
    );

    if (optionToUse === "product_list") {
      // Initialize the carousel for product_list
      this.carouselComplementary = this.element.querySelector(
        "#complementarySwiperElement"
      );
      if (this.carouselComplementary) {
        this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
      }
      if (this.complementaryElWrapper) {
        this.complementaryElWrapper.style.display = "block";
      }

      if (this.complementaryElWrapper.querySelector('.swiper-wrapper').scrollWidth > this.complementaryElWrapper.querySelector('.swiper-wrapper').clientWidth) {
        new CustomCursor(false, this.complementaryElWrapper, false, false, 'slide');
      }
      return; // Skip fetch logic
    }

    // Fetch logic for other cases
    let url = `${window.routes.recommended_products_url}?section_id=complementary_products_pdp&product_id=${this.options["product_id"]}&limit=10&intent=${optionToUse}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    let content = await response.text();
    content = new DOMParser().parseFromString(content, "text/html");
    let hasProducts;

    const contentToInsert = content.querySelector(
      ".complementaryProducts--section"
    );

    const elementToReplace = this.element
      .querySelector(".product-info__complementary-swiper")
    elementToReplace.replaceWith(contentToInsert);

    this.carouselComplementary = this.element.querySelector(
      "#complementarySwiperElement"
    );


    if (this.carouselComplementary) {
      this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
    }

    this.childEl = this.element.querySelector(
      ".product-info--complementary-image"
    );



    hasProducts = this.childEl;


    if (this.complementaryElWrapper && hasProducts) {

      this.complementaryElWrapper.style.display = "block";

      setTimeout(() => {
        if (this.complementaryElWrapper.querySelector('.swiper-wrapper').scrollWidth > this.complementaryElWrapper.querySelector('.swiper-wrapper').clientWidth) {
          new CustomCursor(false, this.complementaryElWrapper, false, false, 'slide');
        }
      }, 100);
    }
  }


  // Change image quality to high resolution
  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}

// Define the custom element
customElements.define("product-component", ProductElement);
class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this; // reference to our element
  }

  connectedCallback() {
    // Keep this minimal: just init, observe resize, bind events, do initial layout
    this.initElements();
    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  /**
   * Query DOM elements, ensure plus/minus buttons at the end of the wrapper
   */
  initElements() {
    this.selectBoxWrapper = this.querySelector(".product-info__connected-wrapper");
    this.variants = Array.from(this.querySelectorAll(".product-info__connected-color"));
    this.totalVariants = this.variants.length;

    // If you have dedicated plus/minus buttons in the DOM:
    this.plusButton = this.querySelector(".variants-show-more_button_plus");
    this.minusButton = this.querySelector(".variants-show-more_button_minus");

    // Ensure buttons are appended last in the wrapper
    if (this.plusButton) {
      this.selectBoxWrapper.appendChild(this.plusButton);
    }
    if (this.minusButton) {
      this.selectBoxWrapper.appendChild(this.minusButton);
    }
  }

  /**
   * If you have a custom responsive utility, use that;
   * otherwise, fall back to window resize
   */
  observeResize() {
    if (typeof responsive !== "undefined" && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize.bind(this));
    } else {
      window.addEventListener("resize", this.handleResize.bind(this));
    }
  }

  /**
   * Use your original approach (Delegate) to bind show-more / show-less
   */
  bindEvents() {
    // We attach delegate to the wrapper (or this.element) - your choice
    this.delegateElement = new Delegate(this.selectBoxWrapper);

    // Show more
    this.delegateElement.on(
      "click",
      '[data-action="show-more"]',
      this.showAllVariants.bind(this)
    );

    // Show less
    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLessVariants.bind(this)
    );
  }

  /**
   * Main layout logic: measure how many variants fit in one row,
   * ensuring the + x more button (if needed) is also in the same row.
   */
  calculateLayout() {
    if (!this.selectBoxWrapper) return;

    // Temporarily show everything so we can measure
    this.variants.forEach((variant) => {
      variant.style.display = ""; // revert to default (inline-block/flex)
    });
    // Show plus, hide minus for measurement
    if (this.plusButton) this.plusButton.style.display = "";
    if (this.minusButton) this.minusButton.style.display = "none";

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    // If no variants, just hide plus/minus
    if (this.totalVariants === 0) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
      return;
    }

    // Measure a single variant's width (use first variant as a reference)
    const singleVariantWidth = this.variants[0].offsetWidth;
    // Gap (if you have margin, measure it via getComputedStyle; here we assume 4px)
    const variantGap = 8;

    // Measure plus button width
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;
    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    // Figure out how many variants we can fit in one row
    for (let i = 0; i < this.variants.length; i++) {
      // Width for this variant (plus gap if it's not the first)
      const widthNeeded = variantGap + singleVariantWidth;

      // If there's another variant *after* this one,
      // we must reserve space for the plus button in THIS row.
      const stillMoreVariantsRemain = (i < this.variants.length - 1);
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;


      // Check if this variant + plus button (if more remain) fits
      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;

      } else {
        // As soon as we can't fit the next variant + button, we stop
        break;
      }
    }

    // If all variants fit, hide plus/minus
    if (itemsInFirstRow >= this.totalVariants) {
      // Show all
      this.variants.forEach((variant) => {
        variant.style.display = "";
      });
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
    } else {
      // We show only itemsInFirstRow
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? "" : "none";
      });

      // Show plus button with the correct count
      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = "";
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      // Hide minus button initially
      if (this.minusButton) {
        this.minusButton.style.display = "none";
      }
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  /**
   * Show all items, hide plus button, show minus button
   */
  showAllVariants(event, target) {
    // Show all variants
    this.variants.forEach((variant) => {
      variant.style.display = "";
    });
    // Hide plus button
    if (this.plusButton) {
      this.plusButton.style.display = "none";
    }
    // Show minus with updated text
    if (this.minusButton) {
      this.minusButton.innerText = `- ${this.remaining} less`;
      this.minusButton.style.display = "";
    }
  }

  /**
   * Collapse items back to what fits in one row
   */
  showLessVariants(event, target) {
    this.calculateLayout();
  }
}

customElements.define("variant-selectbox", VariantSelectBox);




class connectedProducts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.header = this.element.querySelector('.product-info__connected-header');
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    if (this.element.querySelector('.swiper')) {
      new RevolutionSwiper(this.element.querySelector('.swiper'));
    }

    this.delegateElement.on('mouseover', '[data-action="hover-item"]', this.hoverItem.bind(this));
    this.delegateElement.on('mouseout', '[data-action="hover-item"]', this.hoverItem.bind(this));
    this.delegateElement.on('click', '[data-action="hover-item"]', this.clickItem.bind(this));
  }

  clickItem(event) {
    const link = event.target.querySelector('a'); // Find the first child link
    if (link) {
      link.click(); // Simulate a click on the link
    }
  }
  hoverItem() {
    let name = event.target.getAttribute('data-color');
    if (event.type == 'mouseout') {
      name = this.element.dataset.colorOriginal;
    }

    if (name) {
      this.header.innerText = name;
    }
  }
}
customElements.define("connected-products", connectedProducts);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.atcButtons = document.querySelectorAll(".product__atc-button");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.notifyStickyAddButton = document.querySelector(
      ".product-module__product-atc"
    );


    this.regularPrice = document.querySelector(
      "product-component .product-info__price--regular span"
    );
    this.compareAtPrice = document.querySelector(
      "product-component .product-info__price--compare"
    );

    this.pricesWrapper = document.querySelector(
      ".product-info__price"
    );
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    this.bindEvents();


    if (this.checkIfAllSelected()) {
      this.onVariantChange();
    }
  }

  checkIfAllSelected() {
    //I check if they are all selected
    let allSelected = true;
    const variants_content = this.element.querySelectorAll('.RevolutionSelectbox--Content');

    variants_content.forEach(content => {
      const hasSelectedChild = Array.from(content.children).some(child => child.hasAttribute('selected'));

      if (!hasSelectedChild) {
        allSelected = false; // If one parent is missing a selected child, set allSelected to false
      }
    });

    return allSelected;
  }

  bindEvents() {
    var selectboxes = this.element.querySelectorAll("select");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.product-info__actions .product__atc-button').click();
  }


  onVariantChange() {
    if (this.checkIfAllSelected()) {
      this.updateOptions();
      this.updateMasterId();


      this.updateVariantStatuses();
      this.updateMedia();
      this.updateURL();
      this.updatePriceOnVariant();
      this.updatePriceBlock();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateLowestPrice();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );

  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(
      ".product-info__price--lowest span"
    );

    const lowestPriceDiv = document.querySelectorAll(
      ".product-info__price--lowest"
    );

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(
            lowestPrice,
            window.theme.moneyFormat
          );
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = "flex";
        });

        if (lowestPrice == 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateVariantStatuses() {
    // If .VariantSelect is the container, we need to find the <select> inside each
    const selectContainers = [...this.querySelectorAll(".variant-select")];

    // Map containers to their <select> elements
    const selectElements = selectContainers.map(
      (container) => container.querySelector("select")
    );

    // Collect selected values
    const selectedValues = selectElements.map((select) => ({
      name: select.name,
      value: select.value
    }));


    // Filter variants by the first select’s value
    const selectedOptionOneValue = selectedValues[0]?.value;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => variant.option1 === selectedOptionOneValue
    );

    // For each subsequent select
    selectElements.forEach((currentSelect, index) => {
      if (index === 0) return; // skip the first select

      const previousSelectValue = selectElements[index - 1].value;

      // Which values remain available for the current option (option{index+1})?
      const availableOptionValues = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousSelectValue
        )
        .map((variant) => variant[`option${index + 1}`]);

      // enable/disable the <option> elements

      this.setSelectAvailability(currentSelect, availableOptionValues);
    });
  }





  setSelectAvailability(selectElement, listOfAvailableOptions) {

    const buttons = selectElement.parentElement.querySelector('.RevolutionSelectbox--Content').querySelectorAll('button');

    buttons.forEach((option) => {

      if (listOfAvailableOptions.includes(option.dataset.value)) {


        option.classList.remove("variant-notify-me");
        option.innerHTML = `<span>${option.dataset.value}</span>`;
      } else {


        option.classList.add("variant-notify-me");
        option.innerHTML = `<span>${option.dataset.value}</span> <sup class="u-p4">${window.variantStrings.notify_me}</sup>`;
      }
    });
  }


  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {

    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updatePriceOnVariant() {
    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "variant",
          price_raw: this.currentVariant.price,
          compare_at_price: this.currentVariant.compare_at_price,
        },
      })
    );
  }

  updatePriceBlock() {
    if (this.regularPrice) {
      this.regularPriceTag = this.currentVariant.price;
      this.regularPrice.innerHTML = Shopify.formatMoney(
        this.regularPriceTag,
        window.theme.moneyFormat
      );
    }
    if (this.compareAtPrice) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      if (this.compareAtPriceTag) {
        this.compareAtPrice.innerHTML = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
      } else {
        this.compareAtPrice.innerText = "";
      }
    } else if (this.currentVariant.compare_at_price && !this.compareAtPrice) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      const compareAtPriceDiv = document.createElement("span");
      compareAtPriceDiv.className = "u-s2 product-info__price--compare";
      compareAtPriceDiv.textContent = `${Shopify.formatMoney(
        this.compareAtPriceTag,
        window.theme.moneyFormat
      )}`;

      if (this.pricesWrapper) {
        this.pricesWrapper.appendChild(compareAtPriceDiv);
        this.compareAtPrice = compareAtPriceDiv;
      }
    } else {
      if (this.compareAtPrice) this.compareAtPrice.innerText = "";
    }
  }


  updateVariantInput() {

    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      input.dataset.id = this.currentVariant.id;
      input.value = this.currentVariant.id;
      input.dataset.sku = this.currentVariant.sku;
      if (this.currentVariant.sku)
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".product-info__prices-wrapper";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        this.toggleAddButton();
      });
  }

  toggleAddButton() {


    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });

    const addButton = document.querySelectorAll(".product__atc-button");



    if (!addButton) return;


    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });


    } else {
      addButton.forEach((button) => {
        button.dataset.action = 'add-to-cart';
        if (button.classList.contains('product-module__product-atc--sticky')) {
          button.dataset.action = 'click-atc';
        }

        button.classList.remove("hideBtn");
        const addToCartTxt = button.querySelectorAll('.product__atc-button .ButtonText');
        addToCartTxt.forEach(txt => {
          txt.textContent = window.variantStrings.addToCart;
        })

      });


    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {

    if (!this.notifyButtons) return;
    const element = document.querySelector('[data-preorder]');
    let preorder = false;
    if (element && element.dataset.preorder != '') {
      const preorderIds = JSON.parse(element.getAttribute('data-preorder')).map(Number);;
      if (preorderIds.includes(this.currentVariant.id)) {
        preorder = true;
      }
    }

    if (available && !preorder) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class Cache {
  constructor(maxCacheSize = 1) {
    this.maxCacheSize = maxCacheSize; // The maximum number of results to cache
    this.cache = []; // Array to hold cached results
  }

  addData(key, data) {
    // Check if the result is already cached
    const existingIndex = this.cache.findIndex((item) => item.key === key);

    if (existingIndex !== -1) {
      // If the result is already in the cache, remove it
      this.cache.splice(existingIndex, 1);
    }

    // Add the new result to the beginning of the cache
    this.cache.unshift({ key, data });

    // Remove the oldest cached result if cache exceeds the max size
    if (this.cache.length > this.maxCacheSize) {
      this.cache.pop();
    }
  }

  getCachedData(key) {
    // Find the cached result for the given key
    const cachedItem = this.cache.find((item) => item.key === key);
    return cachedItem ? cachedItem.data : null;
  }
}
class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.queryCarouselElement = this.element.querySelector(
      "#search__query-container.swiper"
    );
    if (this.queryCarouselElement)
      this.queryCarousel = new RevolutionSwiper(this.queryCarouselElement);
    this.cachedResults = new Cache();

    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(
      ".search__dynamic-content"
    );
    this.searchHeader = this.element.querySelector(".search__header");
    this.pageOverlayElement = document.getElementById("search__page-overlay");
    this.clearSearchButton = this.element.querySelector(
      ".search__input-clear"
    );
    this.queryList = this.element.querySelector(".search__queries");
    this.searchIcon = this.element.querySelector(".search__icon");

    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    new AddToCart(this.element);
    this.updateHeaderHeight();
    this.appendRecentSearches();
    this.initializeSwiper(true);
    this.bindEvents();
  }

  updateHeaderHeight() {
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", false);
    }
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchHeader.offsetHeight}px`
    );
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", true);
    }

    if (this.isOpen) {
      this.searchResultsElement.style.height = this.element.querySelector('.search__results').scrollHeight + 'px';
    }
  }

  initializeSwiper(initialLayout) {
    this.carouselElement = this.searchResultsElement.querySelector(
      "[data-results] .swiper"
    );

    const collectionsCarousel = this.searchResultsElement.querySelector('.search__results--collections');

    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
    if (initialLayout) {
      this.swiperCursor = new CustomCursor(false, this.carouselElement, true, false, 'slide');
    }
    if (collectionsCarousel) {
      new RevolutionSwiper(collectionsCarousel);
    }
  }

  bindEvents() {
    this.onInputListener = debounce(this.onInput.bind(this), 450);
    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInputListener
    );

    this.delegateElement.on(
      "keydown",
      '[name="q"]',
      this.onInputListener
    );

    if (this.element.querySelector('.search__product-title')) {
      this.delegateElement.on(
        "mouseenter",
        '[data-action="hover-product"]',
        this.hoverProduct.bind(this),
        true
      );
      this.delegateElement.on(
        "mouseleave",
        '[data-action="hover-product"]',
        this.unHoverProduct.bind(this),
        true
      );
    }

    responsive.addResizeListener(this, this.updateHeaderHeight.bind(this));
    window.addEventListener("load", this.updateHeaderHeight.bind(this));

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  hoverProduct(e) {
    clearTimeout(this.hoverTimeout);
    this.element.querySelector('.search__product-title').innerHTML = e.target.closest('[data-action]').dataset.title;
  }

  unHoverProduct(e) {
    this.hoverTimeout = setTimeout(() => {
      this.element.querySelector('.search__product-title').innerHTML = '';
    }, 150);
  }

  openSearch(e) {
    e.preventDefault();

    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch(e);
      return;
    }

    this.firstSinceOpen = true;

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.element.removeEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );

    this.element.setAttribute("aria-hidden", false);

    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", true)
        this.isOpen = true;
        this.pageOverlayElement.classList.add("is-visible");
        document.body.classList.add('scrollLock');
        bodyScrollLock.disableBodyScroll(
          this.element.querySelector("[data-scrollable]"),
          bodyScrollLockOptions
        );
      })
    );

    this.setWidthOfSearchDropdown("open");

    // Focus on search input element after delay
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);

    // If header is transparent, remove it's transparency
    const header = document.querySelector(".header--transparent");
    if (header) {
      header.style.transition = "none";
      header.classList.remove("header--transparent");
      document.querySelector('slider-announcement-bar').classList.add('announcement__bar-bg-open');
      window.headerTransparent = true;
      setTimeout(() => {
        header.style.transition = "";
      }, 50);
    }

    if (responsive.matchesBreakpoint('pocket')) {
      document.getElementById('header').toggleColor();
    }

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);

      this.overlayCursor = new CustomCursor(false, this.pageOverlayElement, false, false, 'close');
    }

    if (this.element.querySelector('.search__results-inner-container--initial')) {
      this.swiperCursor = new CustomCursor(this.carouselElement.querySelector('#search__swiper-cursor'), this.carouselElement, true);
    }
  }

  setWidthOfSearchDropdown(string) {
    if (string === "open") {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        const scrollbarWidth = window
          .getComputedStyle(document.body)
          .getPropertyValue("padding-right");
        this.element.style.width = `calc(100% - ${scrollbarWidth})`;
      }
    } else {
      this.element.style.width = `100%`;
    }
  }

  closeSearch(e) {
    if (e) {
      e.preventDefault();
    }
    if (!this.isOpen) {
      return;
    }

    this.clearScrollLock = true;
    if (e && e.type === "close:search") {
      this.clearScrollLock = false;
    }

    this.minimize = false;
    if (e && e.target.closest('[data-action="open-search"]')) {
      this.minimize = true;
    }

    // Hide search dropdown
    this.element.setAttribute("aria-expanded", false);
    this.element.addEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );
    this.pageOverlayElement.classList.remove("is-visible");
    if (this.overlayCursor) this.overlayCursor.destroy();
    if (this.swiperCursor) this.swiperCursor.destroy();
    this.isOpen = false;
  }

  handleSearchClose(e) {
    if (e.propertyName != "transform" && e.propertyName != "opacity") return;
    this.element.setAttribute("aria-hidden", true);
    this.element.removeEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );

    if (window.headerTransparent) {
      document.getElementById("header").toggleColor(this.minimize);
    }
    this.minimize = false;

    this.resetSearch();
    if (this.clearScrollLock) {
      document.body.classList.remove('scrollLock');
      bodyScrollLock.enableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }

    this.clearScrollLock = true;

    this.setWidthOfSearchDropdown();
  }

  async onInput(e) {
    this.lastInputValue = e.target.value;

    // Check whether user clicked on a query
    if (e.target.hasAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = e.target.getAttribute("data-value");
      this.searchInputElement.setAttribute("value", this.lastInputValue);
      this.searchInputElement.value = this.lastInputValue;
    } else if (this.lastInputValue === "") {
      this.resetSearch();
      return;
    }

    const cachedResults = this.cachedResults.getCachedData(this.lastInputValue);

    if (!cachedResults) {
      try {
        const response = await fetch(
          `${routes.predictive_search_url}?q=${encodeURIComponent(
            this.lastInputValue
          )}&resources[limit_scope]=each&section_id=search-predictive&resources[options][fields]=title,product_type,variants.title,body,tag,vendor,variants.sku&resources[type]=product,collection`
        );

        if (!response.ok) {
          throw new Error(response.status);
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-predictive");

        const searchResults = resultsMarkup.querySelector(".search__results");
        if (searchResults) {
          this.cachedResults.addData(this.lastInputValue, searchResults);
        }

        await this.appendResults(searchResults);
      } catch (error) {
        console.error("Failed to conduct a search.", error);
        if (error?.code === 20) {
          return;
        }

        throw error;
      }
    } else {
      await this.appendResults(cachedResults);
    }
    this.initializeSwiper();
    if (this.swiperCursor) this.swiperCursor.destroy();
    this.saveRecentSearch();
  }

  appendResults(searchResults) {
    return new Promise((resolve, reject) => {
      const oldResults =
        this.searchResultsElement.querySelector("[data-results]");

      oldResults.classList.remove("visible");
      oldResults.classList.add("search-hidden");
      searchResults.classList.remove("visible");
      searchResults.classList.add("search-hidden");

      const _this = this;

      if (this.element.getAttribute("aria-expanded") == "false") {
        const newResults =
          _this.searchResultsElement.querySelector("[data-results]");
        newResults.classList.add("visible");
        newResults.classList.remove("search-hidden");
      } else {
        const height = this.searchResultsElement.getBoundingClientRect().height;
        const paddingBottom = parseFloat(getComputedStyle(this.searchResultsElement).paddingBottom);

        this.searchResultsElement.style.height = height - paddingBottom + 'px';

        oldResults.addEventListener("transitionend", function onFadeOutEnd() {
          oldResults.removeEventListener("transitionend", onFadeOutEnd);

          _this.searchResultsElement.replaceChild(searchResults, oldResults);


          const newResults =
            _this.searchResultsElement.querySelector("[data-results]");

          requestAnimationFrame(() => {
            setTimeout(() => {
              newResults.classList.add("visible");
              newResults.classList.remove("search-hidden");
              _this.searchResultsElement.style.height = searchResults.scrollHeight + 'px';
            }, 10);
          });

          resolve();
        });
      }
    });
  }

  async resetSearch(e) {
    if (e) e.preventDefault();

    await this.appendResults(
      this.initialSearchLayout.querySelector(".search__results").cloneNode(true)
    );
    this.appendRecentSearches();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    this.initializeSwiper(true);
    this.clearSearchButton.setAttribute("aria-hidden", "true");
    this.searchInputElement.focus();
  }

  saveRecentSearch() {
    if (!window.theme.showRecentSearches) return;

    if (this.lastInputValue.length > 3) {
      var searchTerms = JSON.parse(localStorage.getItem("searchTerms") || "[]");

      // If it doesn't already exist inside the array, push it top the beginning
      if (!searchTerms.includes(this.lastInputValue)) {
        searchTerms.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerms.slice(0, 4))
        );
      } catch (error) { }
    }
  }

  appendRecentSearches() {
    if (!window.theme.showRecentSearches) return;

    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let appendString = "";

    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabindex='0' class='u-p2 search__query-recent hot-spot-mini' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      this.element.querySelector(".search__results-list--recent").innerHTML =
        appendString;
    } else {
      this.element.querySelector(".search__results--recent").style.display =
        "none";
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if (this.element.querySelector("[data-swiper-settings]") && responsive.matchesBreakpoint("phone") || responsive.matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
      window.carousel = this.carousel;
    }

    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  //Reset all sections to display active one 
  //and fresh animation
  resetSection(section) {
    section.style.display = "none";
    section.setAttribute('aria-hidden', 'true');
    section.removeAttribute('data-loaded');

    // Run exit animation
    section.animate(
      [
        { transform: "scale(100%)", opacity: "1" },
        { transform: "scale(96%)", opacity: "0" }
      ],
      { duration: 10, fill: "forwards" }
    );
  }

  handleClick(event) {
    // Get the ID of the clicked button
    const targetButtonId = event.target.id;

    // Find the matching section to show
    const mainFAQ = this.element.querySelector('.FAQ');
    const itemToShow = mainFAQ.querySelector(`#${targetButtonId}`);

    // If no matching section found, return early
    if (!itemToShow) return;

    // Find all FAQ sections except the one to show
    const faqSections = Array.from(this.element.querySelectorAll(".contact-section")).filter(
      section => section.id !== targetButtonId
    );

    // Remove the active class from the previous active link
    const activeLink = this.element.querySelector(".current_link-page");
    if (activeLink) activeLink.classList.remove("current_link-page");

    // Hide non-matching sections
    faqSections.forEach(section => this.resetSection(section));

    // Add "current_link-page" class to the clicked link
    event.target.classList.add("current_link-page");

    // Show the matching section and initialize the animation
    itemToShow.style.display = "flex";
    itemToShow.setAttribute('aria-hidden', 'false');
    new RevolutionAnimation(itemToShow);
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    if (!alreadyExits) {

      new Popup(this.element, true);
      alreadyExits = true;
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");

      document.body.classList.add("scrollLock");
      bodyScrollLock.disableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);

    if (
      (this.element.id === "collection__category-drawer" ||
        this.element.id === "collection__filter-drawer")
    ) {
      this.pageOverlayElement = document.querySelector('.collection__overlay');

    }
    this.customCursor = new CustomCursor(false, this.pageOverlayElement, false, true, 'close');
  }


  closeNewsletter = () => {
    event.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);
class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"), {
      onDrawerOpen: () => {
        const inputToFocus = this.element.querySelector("[aria-visible='true'] .input-placeholder--first");
        if (inputToFocus) {
          inputToFocus.setAttribute("readonly", "readonly");
          inputToFocus.focus();
          inputToFocus.removeAttribute("readonly");
          this.element.querySelector(".accountDrawer--Close").focus();
        }
      },
    });

    this.heading = this.element.querySelector(".account-drawer__header-title");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on("click", '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on("click", '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;
      const recoverError = this.element.querySelector("#recover .accountDrawer--ErrorSpace");
      const recoverSuccess = this.element.querySelector("#recover .accountDrawer--SuccessSpace");
      if (responseText.includes("account__recover-email-error")) {
        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {
        recoverError.classList.remove("is-visible");

        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = "/account";
    const password_check = this.element.querySelector("#RegisterForm-password").value;
    const passwordConfirm_check = this.element.querySelector("#RegisterForm-password-confirmation").value;
    const password_err = this.element.querySelector('#password-error');
    password_err.style.display = 'none';
    if (password_check !== passwordConfirm_check) {
      password_err.style.display = 'block';

      setTimeout(() => {
        password_err.style.display = 'none';

      }, 2000);
      return;
    }

    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
        password_confirm: this.element.querySelector("#RegisterForm-password-confirmation").value
      },
    };
    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("registerErrors")) {
        const registerError = this.element.querySelector("#register .accountDrawer--ErrorSpace");
        registerError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        registerError.innerHTML =
          tempDiv.querySelector(".registerErrors").innerHTML;


        registerError.classList.add("is-visible");

        setTimeout(() => {
          registerError.classList.remove("is-visible");
        }, 2000);
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the registration request:", error);
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = "/account/login";
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.querySelector(".ButtonText");
    const loader = event.target.querySelector(".itemLoader");

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML =
          tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(".accountDrawer--Tab");
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) => content.setAttribute("aria-visible", "false"));

    event.target.setAttribute("aria-expanded", "true");
    const content = this.element.querySelector(`#${id}`);

    if (content) {
      if (id === 'register') {
        this.heading.textContent = this.heading.dataset.register;
      }
      if (id === 'login') {
        this.heading.textContent = this.heading.dataset.login;
      }
      content.setAttribute("aria-visible", "true");
    }
  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id === "recover") {
      this.element.querySelector("#recover").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      this.heading.textContent = this.heading.dataset.recover;
    } else {
      this.element.querySelector("#recover").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      this.heading.textContent = this.heading.dataset.login;
    }
  }
}

customElements.define("account-handler", AccountHandler);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    if (sessionStorage.getItem('announcementBar') === 'hidden') {
      this.closeAnnBar();
    }

    this.updateVisibleHeight();

    this.announcementItems = this.element.querySelectorAll('.annocement-bar__block');
    this.transitionSpeedSliding = this.element.getAttribute("data-settings");
    this.animWrapper = this.element.querySelector(
      ".announcement-bar--anim-wrapper"
    );
    this.original = this.element.querySelector(
      ".announcement-bar--duplicate-wrapper"
    );
    this.spaceDivWidth = 64;

    setTimeout(() => {
    this.bindEvents();
    this.appearAnimation()
    }, 3000);
    if (this.options["animationType"] === "sliding") {
      setTimeout(() => {
        this.element.classList.add("is-visible");
      }, 3001);
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="ann-bar-close"]',
      this.closeAnnBar.bind(this)
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));

    if (this.options["animationType"] === "sliding") {
        
        const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
        responsive.addResizeListener(this, debouncedFunc);
        this.handleBreakpointChange();
      

      if (this.element.dataset.main == "true") {
        scrollListener.addScrollListener(
          this,
          this.updateVisibleHeight.bind(this)
        );
        responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
      }
    }
  }

  closeAnnBar() {
    sessionStorage.setItem('announcementBar', 'hidden');
    this.element.remove();
    this.updateVisibleHeight();
    this.editAnnBarToggle();
  }

  editAnnBarToggle() {
    if (this.options["editAnnBar"] === true) {
      sessionStorage.setItem('announcementBar', 'visible');
    }
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcement-bar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  handleBreakpointChange() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.mobile = false;
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach(
          (block, i) => (block.style.display = "flex")
        );
        this.original.style.justifyContent = "space-between";
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        this.original.style.justifyContent = "center";
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => {
      if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild);
    });
  }

  duplicateBlockWrappers() {
    this.resetWrapper();

    const duplicate = this.original.cloneNode(true);
    const originalWidth = this.original.offsetWidth;

    const wrapperWidth = this.mobile ? 2 * originalWidth + 64 : 2 * originalWidth;

    // Set wrapper width and position
    this.animWrapper.style.width = `${wrapperWidth}px`;
    this.animWrapper.style.position = "absolute";

    this.animWrapper.appendChild(this.original.cloneNode(true));
    this.animWrapper.appendChild(duplicate);
    this.element.style.height = `${this.animWrapper.offsetHeight}px`;

    setTimeout(() => {
      this.startAnimating(wrapperWidth);
    }, 100);
  }

  startAnimating(wrapperWidth) {
    let totalWidth = this.mobile ? wrapperWidth + 64 : wrapperWidth;

    const translateStart = 0;
    const translateEnd = -totalWidth / 2;

    this.animWrapper.style.transform = `translateX(${translateStart}px)`;

    const animation = this.animWrapper.animate(
      [
        { transform: `translateX(${translateStart}px)` },
        { transform: `translateX(${translateEnd}px)` },
      ],
      {
        duration: parseInt(this.transitionSpeedSliding) * 1000,
        iterations: Infinity,
        easing: "linear",
      }
    );

    this.element.addEventListener("mouseenter", () => animation.pause());
    this.element.addEventListener("mouseleave", () => animation.play());
  }

  initialize() {
    this.currentIndex = 0;
    this.announcementItems[this.currentIndex].classList.add('active');
    setInterval(this.showNextElement.bind(this), this.options["cycleSpeed"]);
  }

  showNextElement() {
    this.announcementItems[this.currentIndex].classList.remove('active');
    this.currentIndex = (this.currentIndex + 1) % this.announcementItems.length;
    setTimeout(() => {
      this.announcementItems[this.currentIndex].classList.add('active');
    }, this.options["transitionSpeedAppear"])
  }

  appearAnimation() {
    if (this.options["animationType"] === "appear" && this.options["enableAnimation"]) {
      this.initialize();
    }
    if (this.options["animationType"] === "appear" && !this.options["enableAnimation"]) {
      const announcementItems = this.element.querySelectorAll(".annocement-bar__block");
      const announcementBarWrapper = this.element.querySelector(".announcement-bar--duplicate-wrapper");
      announcementItems.forEach((item) => {
        item.style.opacity = 1;
        item.style.position = "relative";
        item.style.padding = "0rem";
      });
      announcementBarWrapper.style.justifyContent = "space-between";
      announcementBarWrapper.style.width = "100%";
    }
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);



class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;





  }

  connectedCallback() {
    this.carouselElement = this.element.querySelector(".swiper");

    this.carousel = new RevolutionSwiper(this.carouselElement);
    if (this.carousel) {

      // Main carousel slide change event
      this.carousel.swiperElement.on("slideChange",
        this.changeActiveReview.bind(this)
      );

      this.carousel.swiperElement.on("beforeSlideChangeStart",
        this.transitionStart.bind(this)
      );

      this.carousel.swiperElement.on("transitionEnd",
        this.transitionEnd.bind(this)
      );
    }
  }

  transitionStart() {

    const nextActive = this.element.querySelector(".swiper-slide-next");
    //  nextActive.classList.add("soon-active");
  }

  transitionEnd() {

    const active = this.element.querySelector(".swiper-slide-active");
    //  active.classList.remove("soon-active");
  }

  changeActiveReview() {


    const activeSlide = this.element.querySelector(".swiper-slide-active").dataset.swiperSlideIndex;
    const review = this.element.querySelector(`.quote-slide-text[data-index="${activeSlide}"]`);
    const openReview = this.element.querySelector(".quote-slide-text[aria-hidden='false']");

    if (openReview) {
      openReview.setAttribute("aria-hidden", "true");
    }

    review.setAttribute("aria-hidden", "false");

  }
}

customElements.define("quote-slider", QuoteSlider);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlayPDP");
    this.allNotifications = this.element.querySelectorAll(
      ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
      "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
      'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.variantId = document.querySelector(
      '[name="notify_variant"]'
    ).dataset.id;


    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="notify-close-success"]',
      this.closeNotifyMeSuccess.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
    console.log(this.variantId);
  }

  handleSubscribe() {
    event.preventDefault();
    event.stopImmediatePropagation();



    const email = this.element.querySelector('[name="notify_email"]').value;
    this.variantId = document.querySelector('.product-info__block [name="id"]').value;

    const subsButton = this.element.querySelector(".product-module__notify-button--subscribe");
    const btnLoader = this.element.querySelector(".product-module__notify-button--subscribe .itemLoader");

    subsButton.setAttribute("disabled", "true");
    btnLoader.classList.add("is-visible")
    var variantId = this.variantId;
    var variant = window.ORDERSIFY_BIS.product.variants.find(function(variant) {
      return String(variant.id) === String(variantId);
    })
    var product = window.ORDERSIFY_BIS.product;
    fetch('https://bis-web-service.ordersify.com/shopify/notifications', {
      method: "POST",
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: this.productId,
        variant_title: typeof variant !== 'undefined' ? variant.title : '',
        vendor: product.vendor,
        sku: typeof variant !== 'undefined' ? variant.sku : '',
        language: 'en',
        handle: product.handle,
        quantity: 1,
        shop: window.Shopify.shop,
        message: '',
        name: '',
        email: email,
        phone: '',
        send_type: 'email',
        variant_id: this.variantId,
        product_title: product.title,
        variant_image: typeof variant !== 'undefined' ? variant?.featured_image?.src : '',
        product_handle: product.handle,
        variant_price: typeof variant !== 'undefined' ? variant?.price : 0
      })
    }).then((response) => {
      if (response.ok) {
        this.showNotification("success");
      } else {
        this.showNotification("error");
      }
    }).catch(() => {
      this.showNotification("error");
    })

    return;

    // let promise = SI.create(email, this.variantId, this.productId);

    // if (email !== "" && email.includes("@")) {
    //   promise.then((st, data) => {
    //     let resp = SI.parseJSON(data);
    //     if (resp.status == "OK") {
    //       this.showNotification("success");
    //     } else {
    //       this.showNotification("error");
    //     }
    //   });
    // } else {
    //   this.showNotification("email-error");
    // }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--success"
        );
        let activeLabel = this.element.querySelector(
          "label[for='product-module__notify-me-input']"
        );
        let subsBtn = this.element.querySelector(
          ".product-module__notify-button--subscribe"
        );
        subsBtn.style.display = "none";
        activeLabel.style.display = "none";
        activeNotification.setAttribute("aria-hidden", "false");
        this.emailContainer.style.display = "none";
        this.subtitle.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");



    this.customCursor = new CustomCursor(false, this.pageOverlayElement, false, true, 'close');

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.customCursor.destroy();

    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
            this.clearNotifications();
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          this.clearNotifications();
        }
      },
      { once: true }
    );
  }

  closeNotifyMeSuccess(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
        }
      },
      { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);
class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carouselContainer = this.element.querySelector(".usp-section__swiper-container")
    this.carousel = null;
    this.enableSwiperControlMob = this.element.getAttribute(
      "data-enable-swiper-m"
    );
    this.enableSwiperControlDes = this.element.getAttribute(
      "data-enable-swiper-d"
    );
    this.fallbackSlides = this.element.querySelector("#fallback-slides");

    this.updateIsMobile();
    this.updateSwiperControl();
    this.bindEvents();

    window.addEventListener("resize", () => {
      this.updateIsMobile();
      this.updateSwiperControl();
    });
  }

  bindEvents() {
    this.initSwiper = this.initSwiper.bind(this);
    this.destroySwiper = this.destroySwiper.bind(this);
    this.showSwiper = this.showSwiper.bind(this);
    this.hideSwiper = this.hideSwiper.bind(this);
  }

  updateIsMobile() {
    this.isMobile = responsive.matchesBreakpoint("pocket");
  }

  updateSwiperControl() {
    const slides = this.carouselElement.querySelectorAll(".swiper-slide");
    const shouldEnableOnMobile =
      this.enableSwiperControlMob === "true" && this.isMobile;
    const shouldEnableOnDesktop =
      this.enableSwiperControlDes === "true" && !this.isMobile;

    if ((shouldEnableOnMobile || shouldEnableOnDesktop) && slides.length > 1) {
      this.showSwiper();
      this.initSwiper();
    } else {
      this.destroySwiper();
      this.hideSwiper();
    }
  }

  initSwiper() {
    if (!this.carousel) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  destroySwiper() {
    if (this.carousel) {
      this.carousel.swiperElement.destroy(true, true);
      this.carousel = null;
    }
  }

  showSwiper() {
    this.carouselContainer.style.display = "block";
    this.fallbackSlides.style.display = "none";
  }

  hideSwiper() {
    this.fallbackSlides.style.display = "grid";
    this.carouselContainer.style.display = "none";
  }
}
customElements.define("usp-section", UspSection);

class LegalSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.initObserver();
    this.termsMenuTabsWrapper = document.querySelector(".terms--block");
    if (!new Responsive().matchesBreakpoint("lap_and_up")) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
  initObserver() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const distanceFromTop =
      this.termsMenuTabsWrapper.getBoundingClientRect().top;
    const threshold = 52;
    if (distanceFromTop <= threshold && distanceFromTop > 0) {
      this.termsMenuTabsWrapper.style.boxShadow =
        "0px 4px 12px 0px rgba(20, 20, 20, 0.10)";
    } else {
      this.termsMenuTabsWrapper.style.boxShadow = "none";
    }
  }
}

customElements.define("legal-swiper", LegalSwiper);

class faqSection extends HTMLElement {
  constructor() {
    super();
    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Initialize the Swiper carousel

    if (responsive.matchesBreakpoint('phone') || responsive.matchesBreakpoint('pocket')) {

      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
    }
    // Bind events to the elements
    this.bindEvents();
  }

  // Method to bind events
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );
  }

  // Method to handle search functionality
  handleSearch() {
    const inputValue = this.element.querySelector(".faq--search.mobile").value;
    // Mobile clear button handling
    const clearBtn = this.element.querySelector(
      ".supportFaq--mobileClearBtn"
    );
    if (clearBtn) clearBtn.style.display = inputValue ? "flex" : "none";

    this.showSearchTerms(inputValue);
    this.quickSearch(inputValue);
  }

  showSearchTerms(inputValue) {
    const noneTerms = this.querySelector(".noTerms");
    const originalText = noneTerms.dataset.original || noneTerms.textContent.trim();
    if (!noneTerms.dataset.original) {
      noneTerms.dataset.original = originalText;
    }
    noneTerms.textContent = `${noneTerms.dataset.original} "${inputValue}."`;
  }

  quickSearch(inputSearch) {
    const allSections = this.element.querySelectorAll(".faq-section");
    const divContainers = this.element.querySelectorAll(".faq-terms");
    const searchPlaceholderButton = this.element.querySelector(".supportFaq--searchBtn");

    this.removeAllLinks();
    inputSearch = inputSearch.toLowerCase();

    if (!inputSearch.trim()) {
      this.clearSearch();
      // Skip further filtering
      return;
    }
    // Perform search logic for non-empty input
    allSections.forEach((section) => {
      searchPlaceholderButton.style.display = "none";
      // Track if the section has matches
      let sectionMatches = false;

      divContainers.forEach((container) => {
        const containerText = container.textContent.toLowerCase();
        const matches = containerText.includes(inputSearch);

        // Update container visibility
        container.classList.toggle("supportFaq--showed", matches);
        container.style.display = matches ? "block" : "none";

        // Check if this container belongs to the current section
        const faqSection = container.closest(".faq-section");
        if (faqSection === section && matches) {
          sectionMatches = true;
        }
      });
      // Show the section only if it has matches
      section.style.display = sectionMatches ? "flex" : "none";
    });

    this.handleTitles();
    this.handleNoResults(divContainers);
  }

  // Method to handle title visibility
  handleTitles() {
    const allTitles = this.element.querySelectorAll(".faq-subheader_title");
    let firstTitle = true;

    allTitles.forEach((title) => {
      const parent = title.closest(".faq-section");
      const showed = parent.querySelector(".supportFaq--showed");

      title.style.display = showed ? "block" : "none";

      if (!showed) {
        parent.style.display = "none";
      }

      if (showed && firstTitle) {
        parent.classList.add("FAQSubheader--firstTitle");
        firstTitle = false;
      }
    });
  }

  // Method to handle "no results" text visibility
  handleNoResults(containers) {
    const noResults = ![...containers].some((container) =>
      container.classList.contains("supportFaq--showed")
    );
    const noResEl = this.querySelectorAll(".faq-no_results_text");

    noResEl.forEach((item) => {
      item.style.display = noResults ? "flex" : "none";
      item.classList.toggle("noResult--showed", noResults);
    });
  }

  //Reset all sections to display active one 
  //and fresh animation
  resetSection(section) {
    section.style.display = "none";
    section.setAttribute('aria-hidden', 'true');
    section.removeAttribute('data-loaded');

    // Run exit animation
    section.animate(
      [
        { transform: "scale(100%)", opacity: "1" },
        { transform: "scale(96%)", opacity: "0" }
      ],
      { duration: 10, fill: "forwards" }
    );
  }

  clearSearch() {
    const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile");
    const noResEl = this.element.querySelector(".faq-no_results_text");
    const firstLink = this.element.querySelector(".faq-link_list_item");
    const firstSection = this.element.querySelector(".faq-section");
    const allSections = this.element.querySelectorAll(".faq-section");
    const searchPlaceholderButton = this.element.querySelector(".supportFaq--searchBtn");
    const faqTermsDivs = this.element.querySelectorAll(".faq-terms");

    // Reset search input
    if (inputValue) inputValue.value = "";

    // Hide elements that should be hidden initially
    if (clearBtn) clearBtn.style.display = "none";
    if (noResEl) noResEl.style.display = "none";
    if (searchPlaceholderButton) searchPlaceholderButton.style.display = "block";

    // Reset FAQ term sections
    faqTermsDivs.forEach(section => section.style.display = "block");

    // Reset and hide all FAQ sections
    allSections.forEach(section => this.resetSection(section));

    // Show the first section
    if (firstSection) {
      firstSection.style.display = "flex";
      firstSection.setAttribute('aria-hidden', 'false');
      new RevolutionAnimation(firstSection);
    }

    // Activate the first link
    if (firstLink) firstLink.classList.add("current_link-page");
  }

  handleClick(event) {
    const inputValue = this.element.querySelector(".faq--search.mobile");

    // Clear search if there's a value in the search input
    if (inputValue && inputValue.value) {
      this.clearSearch();
    }

    // Get the ID of the clicked button
    const targetButtonId = event.target.id;

    // Find the matching section to show
    const mainFAQ = this.element.querySelector('.FAQ');
    const itemToShow = mainFAQ.querySelector(`#${targetButtonId}`);

    // If no matching section found, return early
    if (!itemToShow) return;

    // Find all FAQ sections except the one to show
    const faqSections = Array.from(this.element.querySelectorAll(".faq-section")).filter(
      section => section.id !== targetButtonId
    );

    // Remove the active class from the previous active link
    const activeLink = this.element.querySelector(".current_link-page");
    if (activeLink) activeLink.classList.remove("current_link-page");

    // Hide non-matching sections
    faqSections.forEach(section => this.resetSection(section));

    // Add "current_link-page" class to the clicked link
    event.target.classList.add("current_link-page");

    // Show the matching section and initialize the animation
    itemToShow.style.display = "flex";
    itemToShow.setAttribute('aria-hidden', 'false');
    new RevolutionAnimation(itemToShow);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".current_link-page");
    linkedItems.forEach((item) => {
      item.classList.remove("current_link-page");
    });
  }
}

customElements.define("faq-section", faqSection);

class FAQContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-faq", FAQContactSection);

function replaceBreadcrumbsText() {
  const breadcrumbs = document.querySelectorAll(".breadcrumbs__list");
  breadcrumbs.forEach((breadcrumb) => {
    breadcrumb.classList.remove("breadcrumbs__list--cut");

    if (breadcrumb.scrollWidth > breadcrumb.clientWidth) {
      breadcrumb.classList.add("breadcrumbs__list--cut");
    }
  });
}

window.addEventListener("load", replaceBreadcrumbsText);
responsive.addResizeListener(this, replaceBreadcrumbsText);

const MAX_RECENT_SEARCHES = 4;
class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.input = this.element.querySelector('.main-search__search-input');
    this.filterBar = this.element.querySelector(".collection__nav-filter-bar");
    this.recentSearchesList = this.element.querySelector(".main-search__recent-list");

    this.onLoad();
    if (this.recentSearchesList) this.renderRecentSearches();
    this.bindEvents();
  }

  bindEvents() {
    if (this.input) {
      this.delegateElement.on(
        "click",
        '[data-action="clear-input"]',
        this.clearInput.bind(this)
      );
    }

    if (this.element.querySelector('.main-search__query')) {
      this.delegateElement.on(
        "click",
        '[data-action="search-term"]',
        this.search.bind(this)
      );
    }
  }

  renderRecentSearches() {
    const recentSearches = JSON.parse(localStorage.getItem('NONAJAX_recentSearches')) || [];
    const clone = this.recentSearchesList.firstElementChild.cloneNode(true);
    this.recentSearchesList.innerHTML = "";

    recentSearches.forEach(search => {
      const clonedClone = clone.cloneNode(true);
      clonedClone.textContent = search;
      this.recentSearchesList.appendChild(clonedClone);
    });

    if (recentSearches.length > 0) document.querySelector('.main-search__recent-queries').setAttribute('aria-hidden', false);
  }

  saveSearch(query) {
    let recentSearches = JSON.parse(localStorage.getItem('NONAJAX_recentSearches')) || [];
    recentSearches = recentSearches.filter(search => search !== query);
    recentSearches.unshift(query);

    if (recentSearches.length > MAX_RECENT_SEARCHES) {
      recentSearches = recentSearches.slice(0, MAX_RECENT_SEARCHES);
    }

    localStorage.setItem('NONAJAX_recentSearches', JSON.stringify(recentSearches));
  }

  onLoad() {
    if (this.element.querySelector('.main-search__wrapper--empty')) return;
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');

    if (query && query != "" && query.length > 3) {
      this.saveSearch(query.toLowerCase());
    }
  }

  search(e) {
    this.input.value = e.target.innerHTML;
    this.input.parentElement.submit();
  }

  clearInput(e) {
    e.preventDefault();
    this.input.value = "";
    this.input.focus();
  }
}
customElements.define("search-component", MainSearch);

class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector(".Comments--WhireButton");
    this.revealWrapper = this.element.querySelector(".Comments--RevealWrapper");
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.openedCom = this.querySelector(".show-comments");
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector(
      ".Comments--ArticleWrapper"
    );

    const swiper = new Swiper(".ArticleComments", {
      // Default parameters
      slidesPerView: 1,

      grid: {
        rows: 3, // your amount of slides
        fill: "row",
      },
      spaceBetween: 0,
      pagination: {
        el: "#blog_comments_swiper-pagination",
        type: "bullets",
        clickable: true,
        bulletClass: "comments-section__swiper-pagination-bullet",
        bulletActiveClass: "comments-section__swiper-pagination-bullet--active",
        dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: ".nextEl",
        prevEl: ".prevEl",
      },
      mousewheel: {
        forceToAxis: true,
      },
      loop: false,

      breakpoints: {
        1025: {
          slidesPerView: 1,

          grid: {
            rows: 3,
          },
          spaceBetween: 0,
        },
      },
    });

    if (this.articleWrapper)
      this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector(".pagination__wrapper");

    const beenHere = sessionStorage.getItem("postRequest");
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }

    this.mobile = new Responsive().matchesBreakpoint;
    this.toggleButton();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.textArea = this.element.querySelector("#CommentForm-body");
    const formListener = this.element.querySelector("#comment_form");
    if (formListener) {
      formListener.addEventListener("submit", this.verifyForm.bind(this));
    }
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });


    if (this.buttonState == true) {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .removeAttribute("disabled");
    } else {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .setAttribute("disabled", true);
    }
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );
    const uncheckedCheckboxes = [];

    requiredCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        e.preventDefault();
        uncheckedCheckboxes.push(checkbox);
      }
    });

    if (uncheckedCheckboxes.length > 0) {
      uncheckedCheckboxes.forEach((checkbox) => {
        const errorMessageElement = checkbox.parentElement
          .querySelector(`label[for=${checkbox.id}]`)
          ?.querySelector(".Comments--ErrorMessage");
        if (errorMessageElement)
          errorMessageElement.classList.add("showCommentErrorMsg");
      });
    } else {
      if (this.currentPageKey.includes("#comment_form")) {
        sessionStorage.setItem("postRequest", this.currentPageKey);
      } else {
        sessionStorage.setItem(
          "postRequest",
          this.currentPageKey + "#comment_form"
        );
      }
    }
  }

  extractStringFromURL(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }
}
customElements.define("comment-section", CommentSection);

class BlogSection extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.carousel = new RevolutionSwiper(
      this.carouselElement
    );
  }
}
customElements.define("blog-section", BlogSection);

class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".blog_showcase_swiper ");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.delegateElement = new Delegate(this.element);
    this.carouselElementTags = this.element.querySelector(
      ".blog_showcase_tags_swiper"
    );
    this.carouselTags = new RevolutionSwiper(this.carouselElementTags);
    this.shown_tags = this.element.querySelectorAll(".blogshowcase_tag");
    this.view_all_button = this.element.querySelector(
      ".blog_showcase_button_wrapper"
    );

    const initial_selected_tag = this.shown_tags[0];
    const initial_selected_tag_selected =
      initial_selected_tag.getAttribute("data-value");
    let view_all_link = this.view_all_button.getAttribute("data-link");
    this.view_all_button
      .querySelector("a")
      .setAttribute(
        "href",
        "blogs/" +
        `${view_all_link}` +
        "/tagged/" +
        `${initial_selected_tag_selected}`
      );
    this.toggleTags(event, initial_selected_tag);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tags"]',
      this.toggleTags.bind(this)
    );
  }

  toggleTags(event, target) {
    this.shown_tags.forEach((tag) => {
      tag.setAttribute("tag-status", "not-selected");
    });
    target.setAttribute("tag-status", "selected");

    const selected_tag = target.getAttribute("data-value");
    let articles = this.element.querySelectorAll(".blog-article");
    articles.forEach((article) => {
      let article_link = article.querySelector("a");
      let blog_tags = article_link.getAttribute("data-tag");
      let blog_tags_array = blog_tags.split(";");

      if (blog_tags_array.includes(selected_tag)) {
        article.style.display = "block";
      } else if (!blog_tags_array.includes(selected_tag)) {
        article.style.display = "none";

      }
    });

    let view_all_link = this.view_all_button.getAttribute("data-link");
    this.view_all_button
      .querySelector("a")
      .setAttribute(
        "href",
        "blogs/" + `${view_all_link}` + "/tagged/" + `${selected_tag}`
      );
  }
}
customElements.define("blog-showcase", BlogShowcaseSlider);


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.syncWidth.bind(this));
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

new dynamicVariables();


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.querySelector(".product-recommendations__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    new AddToCart(this.element)

  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);
  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, "text/html")

      const newSwiper = html.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");
      oldSwiper.swiper.destroy();

      if (newSwiper) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
        new RevolutionSwiper(newSwiper);


        new CustomCursor(false, newSwiper, true, false, 'slide');
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);


class MimicHeadingElement extends HTMLElement {
  constructor() {
    super();
    this._resizeHandler = this.calculateHeightsAndMimicHeadings.bind(this);
  }

  connectedCallback() {
    this.resizeListener = responsive.addResizeListener(this, this.calculateHeightsAndMimicHeadings);
    this.calculateHeightsAndMimicHeadings();
  }

  disconnectedCallback() {
    if (this.resizeListener) {
      this.resizeListener.removeResizeListener();
    }
  }

  // Method that creates or removes divs to mimic the height and spacing of missing headings
  calculateHeightsAndMimicHeadings() {
    if (responsive.matchesBreakpoint('pocket')) {
      const allMimicDivs = document.querySelectorAll('.mimic-heading');
      allMimicDivs.forEach(div => div.remove());
      return;
    }

    const twoColumnsContainers = document.querySelectorAll('.two-columns');

    // Process each `.two-columns` container independently
    twoColumnsContainers.forEach(container => {
      const textBlocks = container.querySelectorAll('.rt-layout__wrapper_text-block');

      for (let i = 0; i < textBlocks.length; i += 2) {
        const oddBlock = textBlocks[i];
        const evenBlock = textBlocks[i + 1];

        if (!evenBlock) continue;

        const headingSelectors = [
          { className: 'text-block__heading', attr: 'data-has-heading' },
          { className: 'text-block__heading--sub', attr: 'data-has-heading-sub' },
        ];

        const existingMimicDivs = evenBlock.querySelectorAll('.mimic-heading');
        existingMimicDivs.forEach(div => div.remove());

        headingSelectors.forEach(({ className, attr }) => {
          const oddHeading = oddBlock.querySelector(`.${className}`);
          const hasEvenHeading = evenBlock.getAttribute(attr) === 'true';

          if (oddHeading && !hasEvenHeading) {
            const styles = window.getComputedStyle(oddHeading);

            const mimicDiv = document.createElement('div');
            mimicDiv.className = 'mimic-heading';

            mimicDiv.style.height = `${oddHeading.offsetHeight}px`;
            mimicDiv.style.marginTop = styles.marginTop;
            mimicDiv.style.marginBottom = styles.marginBottom;
            mimicDiv.style.paddingTop = styles.paddingTop;
            mimicDiv.style.paddingBottom = styles.paddingBottom;
            mimicDiv.style.display = styles.display;
            mimicDiv.style.visibility = 'hidden';

            evenBlock.insertAdjacentElement('afterbegin', mimicDiv);
          }
        });
      }
    });
  }
}

customElements.define('mimic-heading-element', MimicHeadingElement);

class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;
    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}


class SizeGuideTable extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.tableContent = this.element.querySelector(
      ".size-guide__table-content"
    );
    this.scrollbar = this.element.querySelector(".custom-scrollbar");
    this.scrollbarThumb = this.element.querySelector(".custom-scrollbar-thumb");

    this.tableFonts();

    this.scrollBarUpdate();
    this.bindEvents();
  }

  tableFonts() {
    const table = this.element.querySelector(".size-guide__table-content");
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      row.classList.add("table-row");
    });

    const firstRow = table.querySelectorAll("tr:first-of-type td");

    firstRow.forEach((row) => {
      row.classList.add("u-p2");
    });

    const items = this.element.querySelectorAll("td");

    items.forEach((item) => {
      item.classList.add("table__item");
    });
  }

  scrollBarUpdate() {

    this.scrollBarUpdateThumb();

    window.addEventListener("resize", () => this.scrollBarUpdateThumb());
  }

  bindEvents() {
    let isDragging = false;
    let startX, startScrollLeft;
    const slider = this.element.querySelector(".size-guide__table-content");

    const startDragging = (e) => {
      isDragging = true;
      startX = e.type === "touchstart" ? e.touches[0].pageX : e.pageX;
      startScrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
      isDragging = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!isDragging) {
        return;
      }
      const currentX = e.type === "touchmove" ? e.touches[0].pageX : e.pageX;
      const scroll = currentX - startX;
      slider.scrollLeft = startScrollLeft - scroll;

      this.syncScroll();
    };

    document.body.addEventListener('click', (event) => {
      if (event.target.matches('[data-action="tab-switch"]')) {
        this.scrollBarUpdateThumb();
      }
    });
    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("touchstart", startDragging, false);

    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("touchend", stopDragging, false);

    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("touchmove", move, false);

    this.tableContent.addEventListener(
      "scroll",
      () => this.syncScroll(),
      false
    );
  }

  scrollBarUpdateThumb() {
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;

    this.scrollbarThumb.style.width = `${scrollRatio * 100}%`;

    if (contentWidth <= containerWidth) {
      this.scrollbar.style.display = 'none';
    } else {
      this.scrollbar.style.display = 'block';
    }
  }

  syncScroll() {
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;
    const scrollLeft = this.tableContent.scrollLeft;
    this.scrollbarThumb.style.transform = `translateX(${scrollLeft * scrollRatio
      }px)`;
  }
}
customElements.define("size-guide-table", SizeGuideTable);
class sizeGuide extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    new Drawer(this.element.querySelector('.Drawer--wrapper'));


  }

  connectedCallback() {
    this.bindEvents();
    this.initFirstTab();
    this.initSlider();
  }

  initSlider() {
    const hasSlider = this.element.querySelector('[data-init-slider]');
    if (!hasSlider) { return; }

    const slider = hasSlider.querySelector('.swiper');
    new RevolutionSwiper(slider);


  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-unit"]', this.toggleUnit.bind(this));
    this.delegateElement.on('click', '[data-action="tab-switch"]', this.tabSwitch.bind(this));
  }

  toggleTab(e) {
    const id = e.target.dataset.id;
    const tab = this.element.querySelector(`#${id}`);

    const openTab = this.element.querySelector('.sg__ms__tab[aria-expanded="true"]');
    const openTable = this.element.querySelector('.sg__ms__table[aria-hidden="false"]');

    if (tab) {
      openTab.setAttribute('aria-expanded', 'false');
      openTable.setAttribute('aria-hidden', 'true');

      e.target.setAttribute('aria-expanded', 'true');
      tab.setAttribute('aria-hidden', 'false');


    }
  }

  toggleUnit(e) {
    const unit = e.target.dataset.unit;
    e.target.classList.add('active');
    const other = e.target.nextElementSibling || e.target.previousElementSibling;
    other.classList.remove('active');
    const allValues = this.element.querySelectorAll('.table__value');
    if (unit == 'cm') {
      allValues.forEach(item => {
        item.textContent = item.dataset.value + " cm";
      });
    } else {
      allValues.forEach(item => {
        item.textContent = (parseInt(item.dataset.value) * 0.393701).toFixed(2) + " in";
      });
    }
  }

  initFirstTab() {
    const firstContent = this.element.querySelector('.sg__ms__content');
    const firstTab = this.element.querySelector('.size-guide__tab-switch');

    if (firstContent && firstTab) {
      firstContent.setAttribute('aria-hidden', 'false');
      firstTab.setAttribute('aria-expanded', 'true');
    }

  }

  tabSwitch(e) {
    const id = e.target.dataset.id;
    const openTab = this.element.querySelector('.size-guide__tab-switch[aria-expanded="true"]');
    const content = this.element.querySelector(`#${id}`);
    if (!content) { return }

    openTab.setAttribute('aria-expanded', 'false');
    e.target.setAttribute('aria-expanded', 'true');


    const openContent = this.element.querySelector('.sg__ms__content[aria-hidden="false"]');


    openContent.setAttribute('aria-hidden', 'true');
    content.setAttribute('aria-hidden', 'false');



  }


}

customElements.define("size-guide", sizeGuide); class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);

    const languageSelectbox = this.element.querySelector('.country-selector__dropdown--language .RevolutionSelectbox');
    const languageDropdown = languageSelectbox.querySelector('.RevolutionSelectbox--InnerContent');
    const languageTitle = languageSelectbox.querySelector('.RevolutionSelectbox--Title');
    const languageInput = languageSelectbox.querySelector('input');

    const languageSelectboxClone = languageSelectbox.cloneNode(true);
    const selectboxCloneDropdown = languageSelectboxClone.querySelector('.RevolutionSelectbox--InnerContent');
    selectboxCloneDropdown.innerHTML = '';

    languages.forEach((language, index) => {
      const selectboxItem = languageDropdown.firstElementChild.cloneNode();
      selectboxItem.dataset.value = language.iso;
      selectboxItem.dataset.name = language.name;
      selectboxItem.textContent = language.name;
      selectboxItem.removeAttribute('selected');

      if (index == 0) {
        languageInput.value = language.iso;
        languageTitle.innerHTML = language.name;
        selectboxItem.setAttribute('selected', 'selected');
      }

      selectboxCloneDropdown.appendChild(selectboxItem);
    });

    languageSelectbox.parentElement.replaceChild(languageSelectboxClone, languageSelectbox);
    new RevolutionSelectbox(languageSelectboxClone);
  }
}
customElements.define("localization-modal", LocalizationModal);


